import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import usePA_GlobalStore from "../../Services/ZustandGlobalStore";

import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import small_logo from '../../graphics/Color-logo-image-only.png';
import large_logo from '../../graphics/Color_logo_no_background.png';
import {
    Accordion, AccordionDetails, AccordionSummary,
    Alert, Avatar,
    Button, Card, CardContent, CardMedia, Checkbox, Chip,
    Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fade,
    FormControl, FormControlLabel, FormHelperText,
    InputAdornment,
    InputLabel, LinearProgress, ListItem,
    ListItemButton, ListSubheader, Menu, MenuItem,
    OutlinedInput, Switch, Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid';
import {PAContext} from "../../Services/PAContext";
import {GoogleLogin} from "@react-oauth/google";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import './header.css';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    getAllEventsFromDatabase, getAllTemplatesFromDatabase,
    getEventFromDatabase,
    getTemplateFromDatabase
} from "../../Services/BrowserDatabaseFunctions";
import dayjs from "dayjs";
import {capitalizeFirstLetter, formatName, stringAvatar, stringToColor} from "../../components/Helpers/TextStyling";
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import GettingStarted from "../../components/Dialogs/GettingStarted";
import MasterAttendees from "../../components/Dialogs/MasterAttendees";
import Badge from "@mui/material/Badge";
import PAEvent from "../../MasterEventObjects/PAEvent";
import MasterTemplates from "../../components/Dialogs/MasterTemplates";
import { motion, AnimatePresence } from 'framer-motion';
import ListItemIcon from "@mui/material/ListItemIcon";
import UnifiedBudget from "../../components/Dialogs/UnifiedBudget";
import SavePlanning from "../../components/Dialogs/SavePlanning";
import ToDoMaster from "../../components/Dialogs/ToDoMaster";
import MasterLists from "../../components/Dialogs/MasterLists";
import Analyzer from "../../components/Dialogs/Analyzer";
import MasterCalendar from "../../components/Dialogs/MasterCalendar";
import PAAttendee from "../../MasterEventObjects/Attendee";
import UnifiedPoints from "../../components/Dialogs/UnifiedPoints";

import LogoutIcon from '@mui/icons-material/Logout';


// Display Icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import AccountDialog from "../../components/Dialogs/AccountSettings/AccountDialog";
import {usePoints} from "../../Services/PointsContext";




const Header = ({
                    showHeader,
                    setShowHeader,
                    selectedMenuItem,
                    setSelectedMenuItem,
                    setViewingEventGroup,
                    showConciergeServiceWindow,
                    setShowConciergeServiceWindow,
                    showAccountDialog,
                    setShowAccountDialog
                }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject, isSyncing, showCloudSuccess } = usePA_GlobalStore();

    const { activeConnectionCount, activeConnectedUsers, dataArray, sendSocketMessage, setAccount, setSideMenuWidth, setLoginFailed } = useContext(PAContext);
    const { Account, Attendees, authenticated, isMobileView, ws_connected } = dataArray;

    // 1. Snatch the pre-calculated global values instantly
    const { totalAccountPoints, yearlyPoints, loadingEvents, getCurrentTier, getNextTier } = usePoints();

    // 2. Combine them to get your total running score
    const currentPoints = yearlyPoints + totalAccountPoints;
    const runningScoreTotal = currentPoints; // Keep aligned with your view reference

    // Calculate milestone progression metrics dynamically
    const { nextLevel, progress, ptsToNextMilestone, isMaxTier } = useMemo(() => {
        const nextTierObj = getNextTier(currentPoints);

        // If there is no next tier, they are in the highest tier (Trail Blazer)
        if (!nextTierObj) {
            return {
                nextLevel: currentPoints,
                progress: 100,
                ptsToNextMilestone: 0,
                isMaxTier: true
            };
        }

        // The threshold target is the minimum points required to clear the next milestone level
        const targetPoints = nextTierObj.min;
        const computedProgress = Math.min((currentPoints / targetPoints) * 100, 100);
        const distanceLeft = Math.max(0, targetPoints - currentPoints);

        return {
            nextLevel: targetPoints,
            progress: computedProgress,
            ptsToNextMilestone: distanceLeft,
            isMaxTier: false
        };
    }, [currentPoints, getNextTier]);


    const [progressBarIndicator, setProgressBarIndicator] = useState(0);
    useEffect(() => {
        console.log("dataArray.progressBar : "+dataArray.progressBar);
        setProgressBarIndicator(dataArray.progressBar);
    }, [dataArray.progressBar]);



    useEffect(() => {

        const path = location.pathname.replaceAll('/', '');

        if (path === "") {
            setSelectedMenuItem('home');
        } else if (path === "Features") {
            setSelectedMenuItem('features');
        } else if (path === "Pricing") {
            setSelectedMenuItem('pricing');
        } else if (path === "ContactUs") {
            setSelectedMenuItem('contact');
        } else if (path.startsWith("FlightPlanner")) {
            setSelectedMenuItem('flightplanner');
        } else if (path.startsWith("Nano")) {
            setSelectedMenuItem('nano');
        } else if (path.startsWith("Planner")) {
            setSelectedMenuItem('planner');
        } else if (path === "Dashboard") {
            setSelectedMenuItem('dashboard');
        } else if (path === "SignUp") {
            setSelectedMenuItem('signup');
        }

        console.log("getting Events from browser database for : "+Account.id);
        //load and sort any Events from the browser database
        if (Account.id !== undefined && Account.id !== ""){
            console.log("Making a request for all Events ...");
            getAllEventsFromDatabase(Account.id).then((_events) => {
                // 1. Ensure _events is an array. If it's null/undefined, use an empty array.
                const eventsArray = Array.isArray(_events) ? _events : [];

                console.log("the returned Events : ", eventsArray);

                // 2. Use eventsArray for the rest of your logic
                const sorted = [...eventsArray]
                    .filter(event => event.time_table?.dates?.length > 0)
                    .sort((a, b) => {
                        const dateA = dayjs(a.time_table?.dates?.[0]?.date || 0);
                        const dateB = dayjs(b.time_table?.dates?.[0]?.date || 0);
                        return dateB.isAfter(dateA) ? 1 : -1;
                    });

                console.log("sorted Events length : "+sorted.length);
                setSortedEvents(sorted);

                // Process unique locations grouped by state
                const locationsMap = {};

                eventsArray.forEach((event) => {
                    // Use optional chaining and default to empty array
                    (event.lodging || []).forEach((lodging) => {
                        const { city, state } = lodging?.location || {};
                        if (city && state) {
                            const normalizedState = state.trim().toLowerCase();
                            const normalizedCity = city.trim().toLowerCase();

                            if (!locationsMap[normalizedState]) {
                                locationsMap[normalizedState] = new Set();
                            }
                            locationsMap[normalizedState].add(normalizedCity);
                        }
                    });
                });

                // Convert each state's set of cities back to an array and capitalize first letters
                const locationsObj = {};
                for (const [state, citiesSet] of Object.entries(locationsMap)) {
                    const formattedState = state.charAt(0).toUpperCase() + state.slice(1); // Capitalize state
                    locationsObj[formattedState] = Array.from(citiesSet).map(city =>
                        city.charAt(0).toUpperCase() + city.slice(1)  // Capitalize city
                    );
                }

                // Set unique locations as an object with states and their unique cities
                setUniqueLocations(locationsObj);


                //build the list of unique categories for this Account id
                const categoriesSet = new Set();

                eventsArray.forEach((event) => {
                    event.menu_items.forEach((menuItem) => {
                        if (menuItem.id === Account.id) {
                            menuItem.categories.forEach((category) => {
                                categoriesSet.add(category);
                            });
                        }
                    });
                });

                // Set the unique categories as an array
                setUniqueCategories(Array.from(categoriesSet));

            });
        } else {
            console.log("not logged in so no checking for Events!!");
        }


        //load and sort any Templates from the browser database
        getAllTemplatesFromDatabase().then((_templates) => {

            if (_templates && Array.isArray(_templates)) {
                // Convert each template into a PAEvent object
                const convertedTemplates = _templates.map(template => new PAEvent(template));

                // Sort templates by title (alphabetically)
                const sorted = [...convertedTemplates].sort((a, b) =>
                    (a.title || '').localeCompare(b.title || '')
                );

                setSortedTemplates(sorted);

            }

        })


    }, []);


    const onLogoClick = () => {
        setSelectedMenuItem('');
        navigate('/');
        setSideMenuWidth(0);
    }
    const onButtonClick = (event) => {
        console.log('button click ', event.target.innerText);

        setAnchorAccountMenu(false);
        setAnchorAccountMenuMobile(false);

        if (event.target.innerText === "Home"){
            setSelectedMenuItem('');
            navigate('/');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Features"){
            setSelectedMenuItem('features');
            navigate('/Features');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Pricing"){
            setSelectedMenuItem('pricing');
            navigate('/Pricing');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Contact Us"){
            setSelectedMenuItem('contact');
            navigate('/ContactUs');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "FlightPlanner"){
            setSelectedMenuItem('flightplanner');
            navigate('/FlightPlanner');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Nano"){
            setSelectedMenuItem('nano');
            navigate('/NanoDashboard');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Templates") {
            // Open the dialog when "Templates" is clicked
            setIsTemplatesDialogOpen(true);
        }
        if (event.target.innerText === "Events") {
            // Open the dialog when "Events" is clicked
            setIsEventDialogOpen(true);
        }
        if (event.target.innerText === "Contacts") {
            // Open the dialog when "Contacts" is clicked
            setIsAttendeesDialogOpen(true);
        }
        if (event.target.innerText === "Lists") {
            setIsMasterListsDialogOpen(true);
        }
        if (event.target.innerText === "Planner"){
            setSelectedMenuItem('planner');
            navigate('/Planner/Itinerary');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Admins"){
            setSelectedMenuItem('admins');
            navigate('/Admins');
            setSideMenuWidth(0);
        }
        if (event.target.innerText === "Login"){
            setIsModalOpen(true);
        }
        if (event.target.innerText === "Logout"){
            //logout
            const _sendString = {};
            _sendString.action = "E_processUserLogout";
            sendSocketMessage(_sendString);
        }
        if (event.target.innerText === "Dashboard"){
            setSelectedMenuItem('dashboard');
            setViewingEventGroup("current");
            navigate('/dashboard');
            authenticated ? setSideMenuWidth(70) : setSideMenuWidth(0);
        }
        if (event.target.innerText === "Sign Up"){
            setSelectedMenuItem('signup');
            navigate('/SignUp');
            setSideMenuWidth(0);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [usernameErrorStatus, setUsernameErrorStatus] = useState(false);
    const [passwordErrorStatus, setPasswordErrorStatus] = useState(false);

    const handleUsernameInputChange = (event) => {
        const inputValue = event.target.value;
        setUsername(inputValue);
        if (inputValue.length > 0){
            setUsernameErrorStatus(false);
            setLoginFailed(false);
        }
    }
    const handlePasswordInputChange = (event) => {
        const inputValue = event.target.value;
        setPassword(inputValue);
        if (inputValue.length > 0){
            setPasswordErrorStatus(false);
            setLoginFailed(false);
        }
    }

    const handleOk = () => {
        console.log("handleOk");

        //check input values
        if (username !== "" && password !== ""){

            const _sendString = {};
            _sendString.action = "E_processUserLogin";
            _sendString.username = username;
            _sendString.password = encode64(password);

            sendSocketMessage(_sendString);

        } else {
            //something wrong with username or password
            username === "" ? setUsernameErrorStatus(true):setUsernameErrorStatus(false)
            password === "" ? setPasswordErrorStatus(true):setPasswordErrorStatus(false)
        }

    };
    const handleCancel = () => {
        console.log("handleCancel");
        setIsModalOpen(false);

    };

    useEffect(() => {
        setIsModalOpen(false);

        if (Account.id !== undefined && Account.id !== "") {
            console.log("Making a request for all Events ... not really");

            getAllEventsFromDatabase(Account.id).then((_events) => {
                console.log("back from the database : ", _events);

                if (_events){
                    const sorted = [..._events]
                        .filter(event => event.time_table?.dates && event.time_table.dates.length > 0) // Check that dates is defined and has elements
                        .sort((a, b) => {
                            const dateA = a.time_table.dates && a.time_table.dates[0] ? dayjs(a.time_table.dates[0].date) : dayjs(0); // Default to an early date if undefined
                            const dateB = b.time_table.dates && b.time_table.dates[0] ? dayjs(b.time_table.dates[0].date) : dayjs(0);
                            return dateB.isAfter(dateA) ? 1 : -1; // Descending order
                        });

                    console.log("sorted Events length : " + sorted.length);
                    setSortedEvents(sorted);

                    // Process unique locations grouped by state
                    const locationsMap = {};

                    _events.forEach((event) => {
                        event.lodging.forEach((lodging) => {
                            const { city, state } = lodging.location || {};
                            if (city && state) {
                                // Normalize to lowercase for comparison and uniqueness
                                const normalizedCity = city.trim().toLowerCase();
                                const normalizedState = state.trim().toLowerCase();

                                // Initialize the state in the map if it doesn't exist
                                if (!locationsMap[normalizedState]) {
                                    locationsMap[normalizedState] = new Set();
                                }

                                // Add city to the state's set (Set automatically handles uniqueness)
                                locationsMap[normalizedState].add(normalizedCity);
                            }
                        });
                    });

                    console.log("locationsMap : ", locationsMap);

                    // Convert each state's set of cities back to an array and capitalize first letters
                    const locationsObj = {};
                    for (const [state, citiesSet] of Object.entries(locationsMap)) {
                        const formattedState = state.charAt(0).toUpperCase() + state.slice(1); // Capitalize state
                        locationsObj[formattedState] = Array.from(citiesSet).map(city =>
                            city.charAt(0).toUpperCase() + city.slice(1)  // Capitalize city
                        );
                    }

                    console.log("locationsObj : ", locationsObj);
                    // Set unique locations as an object with states and their unique cities
                    setUniqueLocations(locationsObj);


                    //build the list of unique categories for this Account id
                    const categoriesSet = new Set();
                    const items = [];

                    _events.forEach((event) => {
                        event.menu_items.forEach((menuItem) => {
                            if (menuItem.id === Account.id) {
                                menuItem.categories.forEach((category) => {
                                    categoriesSet.add(category);
                                });
                            }

                            if (Array.isArray(event.to_do)) {
                                event.to_do.forEach(todo => {
                                    if (todo.assigned_to === Account.id && todo.status !== 0) {
                                        items.push({
                                            ...todo,
                                            event_title: event.title || event.name || 'Untitled',
                                            event_id: event.id,
                                        });
                                    }
                                });
                            }
                        });
                    });

                    console.log("categoriesSet : ", categoriesSet);
                    // Set the unique categories as an array
                    setUniqueCategories(Array.from(categoriesSet));

                    setToDoItems(items);
                    setTotalToDos(items.length);
                }

            });

        }

    }, [Account.id]);


    const keyStr = "ABCDEFGHIJKLMNOP" +
        "QRSTUVWXYZabcdef" +
        "ghijklmnopqrstuv" +
        "wxyz0123456789+/" +
        "=";

    function encode64(input) {
        if (!input) return "";

        // First, we use TextEncoder to convert the string to a UTF-8 byte array.
        // Then, we convert those bytes to a string where each character
        // represents one byte (using map/fromCharCode).
        // Finally, btoa() creates the Base64 string.
        const bytes = new TextEncoder().encode(input);
        const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("");
        return btoa(binString);
    }


    /*
        for the Account Points Dialog
     */
    const [accountPointsDialogOpen, setAccountPointsDialogOpen] = useState(false);

    const [anchorTemplateMenu, setAnchorTemplateMenu] = useState(null);
    const handleTemplateMenuOpenMenu = (event) => {
        setAnchorTemplateMenu(event.currentTarget);
    };
    const handleTemplateMenuClose = () => {
        setAnchorTemplateMenu(null);
    };

    const [sortedTemplates, setSortedTemplates] = useState([]);
    const dialogRefTemplates = useRef(null);
    const [isTemplatesDialogOpen, setIsTemplatesDialogOpen] = useState(false);
    const closeTemplatesDialog = () => {
        setIsTemplatesDialogOpen(false);
    };
    const handleTemplateMenuClick = (template_id) => {
        console.log("handleTemplatesMenuClick");
        console.log("template_id : "+template_id);

        //set the Planner
        getTemplateFromDatabase(template_id).then(specificTemplate => {
            console.log("specificTemplate : "+specificTemplate);

            if (specificTemplate !== null){

                const formattedTemplate = new PAEvent(specificTemplate);

                console.log("the Template : ", formattedTemplate);

                //set the Template
                set_PA_GlobalObject({ Planning: formattedTemplate });

                //navigate to the Planning page if not there already
                setSelectedMenuItem('planner');
                navigate('/Planner/Itinerary');
                setSideMenuWidth(0);

                setIsTemplatesDialogOpen(false);

            } else {
                //no Event found
                console.log("specificTemplate NOT FOUND");

            }
        });

    }


    const [isEventDialogOpen, setIsEventDialogOpen] = useState(false);
    const closeEventDialog = () => {
        setIsEventDialogOpen(false);
    };
    const handleEventMenuClick = (event_id) => {
        console.log("handleEventMenuClick");
        console.log("event_id : "+event_id);

        if (PA_GlobalObject.Planning.id === event_id){
            //the event is already loaded
            setSelectedMenuItem('planner');
            navigate('/Planner/Itinerary');

        } else {
            //set the Planner
            getEventFromDatabase(event_id).then(specificEvent => {

                if (specificEvent !== null){

                    const formattedEvent = new PAEvent(specificEvent);

                    //set the Event
                    set_PA_GlobalObject({ Planning: formattedEvent });

                    /*
                        let AI know of the Event switch
                     */
                    /*
                    sendSocketMessage({
                        action: "CONCIERGE_PROMPT",
                        currentRoute: window.location.pathname, // This is how you get the route!
                        message: "I just loaded a new Event ("+formattedEvent.title+") (event_id: "+specificEvent.id+") into the Planner"
                    });

                     */

                    //navigate to the Planning page if not there already
                    setSelectedMenuItem('planner');
                    navigate('/Planner/Itinerary');

                } else {
                    //no Event found
                    console.log("specificEvent NOT FOUND");

                }
            });
        }
        setSideMenuWidth(0);

        setIsEventDialogOpen(false);

        // Collapse the 'eventList' accordion
        setExpandedAccordions(prev => prev.filter(panel => panel !== 'eventList'));
        // Close the main drawer
        handleAccountMenuMobileOpenMenu(false);

    }
    useEffect(() => {
        if (isEventDialogOpen) {
            console.log("Making a request for all Events ...");
            getAllEventsFromDatabase(Account.id).then((_events) => {
                console.log("back from the database : ", _events);

                if (_events) {
                    const sorted = [..._events].sort((a, b) => {
                        const hasDatesA = a.time_table?.dates?.length > 0;
                        const hasDatesB = b.time_table?.dates?.length > 0;
                        const hasDaysA = a.time_table?.days?.length > 0;
                        const hasDaysB = b.time_table?.days?.length > 0;

                        // Prioritize events with empty dates/days first
                        if (!hasDatesA && !hasDaysA && (hasDatesB || hasDaysB)) return -1;
                        if (!hasDatesB && !hasDaysB && (hasDatesA || hasDaysA)) return 1;

                        // If both have dates, sort by the first available date
                        if (hasDatesA && hasDatesB) {
                            const dateA = dayjs(a.time_table.dates[0].date);
                            const dateB = dayjs(b.time_table.dates[0].date);
                            return dateA.isBefore(dateB) ? 1 : -1;
                        }

                        // If both have empty dates/days, sort alphabetically by title
                        return (a.title || "").localeCompare(b.title || "");
                    });

                    console.log("sorted Events length : " + sorted.length);
                    setSortedEvents(sorted);
                }
            });
        }
    }, [isEventDialogOpen]);

    const [eventTitle, setEventTitle] = useState(PA_GlobalObject.Planning.title || PA_GlobalObject.Planning.name || "");
    useEffect(() => {
        setEventTitle(PA_GlobalObject.Planning.title);
    }, [PA_GlobalObject.Planning.title]);

    const [sortedEvents, setSortedEvents] = useState([]);
    const [sortOrderEvents, setSortOrderEvents] = useState('asc');
    const [uniqueLocations, setUniqueLocations] = useState([]);
    const [uniqueCategories, setUniqueCategories] = useState([]);

    const [anchorElCategory, setAnchorElCategory] = useState(null);
    const [anchorElFilter, setAnchorElFilter] = useState(null);

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedEventAttendees, setSelectedEventAttendees] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [eventPointsDialogOpen, setEventPointsDialogOpen] = useState(false);

    useEffect(() => {

        if (Account.id !== undefined && Account.id !== "") {
            if (selectedLocations.length === 0 && selectedEventAttendees.length === 0){
                console.log("Making a request for all Events ... not really");
                /*
                getAllEventsFromDatabase(Account.id).then((_events) => {

                    const sorted = [..._events].filter(event => event.time_table.dates && event.time_table.dates.length > 0)
                        .sort((a, b) => {
                            const dateA = dayjs(a.time_table.dates[0].date);
                            const dateB = dayjs(b.time_table.dates[0].date);
                            return dateB.isAfter(dateA) ? 1 : -1; // Descending order
                        });

                    setSortedEvents(sorted);
                });

                 */


            } else {
                // Find events matching selected locations
                // Normalize the selected locations to lowercase and trim any spaces
                const normalizedSelectedLocations = selectedLocations.map(location => location.toLowerCase().trim());

                // Filter events based on selected locations
                let locationFilteredEvents = [];
                if (selectedLocations.length > 0) {
                    console.log("Making a request for all Events ...");
                    getAllEventsFromDatabase(Account.id).then((_events) => {

                        locationFilteredEvents = _events.filter(event => {
                            return selectedLocations.length === 0 || event.lodging.some(lodging => {
                                const {city, state} = lodging.location || {};
                                // Compare each city and state separately
                                const normalizedCity = city?.toLowerCase().trim();
                                const normalizedState = state?.toLowerCase().trim();
                                const combinedLocation = `${normalizedCity}, ${normalizedState}`;
                                console.log("comparing : " + normalizedSelectedLocations + " : " + combinedLocation);
                                console.log("888888888888888 result : " + normalizedSelectedLocations.includes(combinedLocation));
                                return normalizedSelectedLocations.includes(combinedLocation);
                            });
                        });

                        console.log("locationFilteredEvents : " + locationFilteredEvents.length);

                        // If there are no selected attendees, don't return all events—return an empty list
                        let attendeeFilteredEvents = [];
                        if (selectedEventAttendees.length > 0) {
                            attendeeFilteredEvents = _events.filter(event =>
                                event.attendees.some(attendee => selectedEventAttendees.includes(attendee.id))
                            );
                        }

                        // Combine both location and attendee filtered events without duplicates
                        const combinedEvents = [...new Set([...locationFilteredEvents, ...attendeeFilteredEvents])];

                        console.log("combinedEvents : " + JSON.stringify(combinedEvents));

                        // Sort the combined events by date (descending order)
                        const sorted = combinedEvents.sort((a, b) => {
                            const dateA = dayjs(a.time_table.dates[0].date);
                            const dateB = dayjs(b.time_table.dates[0].date);
                            return dateB.isAfter(dateA) ? 1 : -1;
                        });

                        console.log("sorted : " + JSON.stringify(sorted));

                        // Set the filtered and sorted events
                        setSortedEvents(sorted);

                    });

                }

            }
        }


    }, [selectedLocations, selectedEventAttendees]);

    useEffect(() => {
        if (Account.id !== undefined && Account.id !== "") {
            console.log("Making a request for all Events ... not really");
            /*
            getAllEventsFromDatabase(Account.id).then((_events) => {
                if (_events) {
                    if (selectedCategories.length === 0) {
                        // No category selected, show all events
                        const sorted = [..._events].sort((a, b) => {
                            // Handle cases where dates might be missing or empty
                            const hasDatesA = a.time_table?.dates?.length > 0;
                            const hasDatesB = b.time_table?.dates?.length > 0;

                            if (!hasDatesA && hasDatesB) return 1; // Events with dates come first
                            if (!hasDatesB && hasDatesA) return -1; // Events without dates go last
                            if (!hasDatesA && !hasDatesB) return a.title.localeCompare(b.title); // Sort by title if both lack dates

                            // If both have dates, sort by first date
                            const dateA = dayjs(a.time_table.dates[0].date);
                            const dateB = dayjs(b.time_table.dates[0].date);
                            return dateB.isAfter(dateA) ? 1 : -1;
                        });

                        setSortedEvents(sorted);
                        return;
                    }

                    // Filter the events based on selected categories and Account.id
                    const categoryFilteredEvents = _events.filter(event => {
                        return event.menu_items.some(menuItem => {
                            return (
                                menuItem.id === Account.id &&
                                menuItem.categories.some(category => selectedCategories.includes(category))
                            );
                        });
                    });

                    setSortedEvents(categoryFilteredEvents);
                }
            });

             */
        }
    }, [selectedCategories]);

    const handleSortToggle = () => {
        setIsUploadMode(false);

        const sorted = [...sortedEvents].filter(event => event.time_table.dates && event.time_table.dates.length > 0) // Only events with valid dates
            .sort((a, b) => {
                const dateA = dayjs(a.time_table.dates[0].date);
                const dateB = dayjs(b.time_table.dates[0].date);

                if (sortOrderEvents === 'asc') {
                    return dateA.isAfter(dateB) ? 1 : -1;
                } else {
                    return dateA.isBefore(dateB) ? 1 : -1;
                }
            });

        // Toggle sort order and update sorted events
        setSortedEvents(sorted);
        setSortOrderEvents((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    // Open the filter menu
    const handleFilterMenuOpen = (event) => {
        setAnchorElFilter(event.currentTarget);
        setIsUploadMode(false);
    };

    // Close the filter menu
    const handleFilterMenuClose = () => {
        setAnchorElFilter(null);
        setIsUploadMode(false);
    };

    // Toggle selected locations
    const handleLocationToggle = (location) => {

        if (selectedCategories.length > 0){
            setSelectedCategories([]);
        }

        if (selectedLocations.includes(location)) {
            setSelectedLocations(selectedLocations.filter(l => l !== location));
        } else {
            setSelectedLocations([...selectedLocations, location]);
        }
    };

    // Toggle selected attendees
    const handleEventAttendeeToggle = (attendeeId) => {

        if (selectedCategories.length > 0){
            setSelectedCategories([]);
        }

        if (selectedEventAttendees.includes(attendeeId)) {
            setSelectedEventAttendees(selectedEventAttendees.filter(id => id !== attendeeId));
        } else {
            setSelectedEventAttendees([...selectedEventAttendees, attendeeId]);
        }
    };

    // Handle category menu open
    const handleCategoryMenuOpen = (event) => {
        console.log("****************** : "+event.currentTarget);
        setAnchorElCategory(event.currentTarget); // Set the anchor element
    };

    // Handle category menu close
    const handleCategoryMenuClose = () => {
        setAnchorElCategory(null); // Close the menu
    };

    // Handle category selection
    const handleCategoryToggle = (category) => {

        if (selectedLocations.length  > 0 || selectedEventAttendees.length > 0){
            setSelectedLocations([]);
            setSelectedEventAttendees([]);
        }
        setSelectedCategories((prevCategories) => {
            if (prevCategories.includes(category)) {
                // Remove the category if already selected
                return prevCategories.filter((cat) => cat !== category);
            } else {
                // Add the category if not already selected
                return [...prevCategories, category];
            }
        });

    };

    const handleReset = () => {
        setSelectedLocations([]);
        setSelectedEventAttendees([]);
        setSelectedCategories([]);
    }

    const dialogRefAttendees = useRef(null);
    const [isAttendeesDialogOpen, setIsAttendeesDialogOpen] = useState(false);
    const closeAttendeesDialog = () => {
        setIsAttendeesDialogOpen(false);
    };
    const handleAttendeeMenuClick = (attendee_id) => {
        console.log("handleAttendeeMenuClick");
        console.log("attendee_id : "+attendee_id);

    }
    const [sortedAttendees, setSortedAttendees] = useState(Attendees);
    const [sortOrderAttendees, setSortOrderAttendees] = useState('asc');
    const [selectedAttendees, setSelectedAttendees] = useState(Attendees);
    const [searchAttendeesFname, setSearchAttendeesFname] = useState('');
    const [searchAttendeesLname, setSearchAttendeesLname] = useState('');

    useEffect(() => {
        const sortedAttendees = [...Attendees].sort((a, b) => {
            const lnameA = (a.lname || '').toLowerCase();
            const lnameB = (b.lname || '').toLowerCase();

            if (lnameA < lnameB) return -1;
            if (lnameA > lnameB) return 1;
            return 0;
        });
        setSortedAttendees(sortedAttendees);
    }, [Attendees]);

    const handleSearchFnameChange = (event) => {
        setIsUploadMode(false);
        console.log("handleSearchFnameChange : "+event.target.value);
        setSearchAttendeesFname(event.target.value); // Update search term
    };
    useEffect(() => {
        console.log("searchAttendeesFname changed");

        const normalizedSearchTerm = searchAttendeesFname.toLowerCase();

        const filteredAttendees = Attendees.filter((att) => {
            return att.fname.toLowerCase().startsWith(normalizedSearchTerm);
        });

        setSortedAttendees(filteredAttendees);

    }, [searchAttendeesFname]);
    const handleSearchLnameChange = (event) => {
        setIsUploadMode(false);
        console.log("handleSearchLnameChange : "+event.target.value);
        setSearchAttendeesLname(event.target.value); // Update search term
    };
    useEffect(() => {
        console.log("searchAttendeesLname changed");

        const normalizedSearchTerm = searchAttendeesLname.toLowerCase();

        const filteredAttendees = Attendees.filter((att) => {
            return att.lname.toLowerCase().startsWith(normalizedSearchTerm);
        });

        setSortedAttendees(filteredAttendees);

    }, [searchAttendeesLname]);

    const handleAttendeeSort = () => {
        setIsUploadMode(false);

        const sortedAttendees = [...Attendees].sort((a, b) => {
            const lnameA = a.lname.toLowerCase();
            const lnameB = b.lname.toLowerCase();
            const fnameA = a.fname.toLowerCase();
            const fnameB = b.fname.toLowerCase();

            if (sortOrderAttendees === 'asc') {
                if (lnameA < lnameB) return -1;
                if (lnameA > lnameB) return 1;
                // If last names are equal, compare first names
                if (fnameA < fnameB) return -1;
                if (fnameA > fnameB) return 1;
                return 0;
            } else {
                if (lnameA > lnameB) return -1;
                if (lnameA < lnameB) return 1;
                // If last names are equal, compare first names
                if (fnameA > fnameB) return -1;
                if (fnameA < fnameB) return 1;
                return 0;
            }
        });

        setSortedAttendees(sortedAttendees);
        setSortOrderAttendees((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };
    const handleAttendeeReset = () => {
        setIsUploadMode(false);
        const sortedAttendees = [...Attendees].sort((a, b) => {
            const lnameA = a.lname.toLowerCase();
            const lnameB = b.lname.toLowerCase();

            if (lnameA < lnameB) return -1;
            if (lnameA > lnameB) return 1;
            return 0;
        });
        setSortedAttendees(sortedAttendees);
    }


    const [isUploadMode, setIsUploadMode] = useState(false);
    const fileInputRef = useRef(null);
    const [originalFileData, setOriginalFileData] = useState([]);
    const [fileDataWithIds, setFileDataWithIds] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedEntries, setSelectedEntries] = useState([]); // To store the selected entries from file
    const [duplicateEmails, setDuplicateEmails] = useState([]);

    const handleUploadClick = () => {
        if (!isUploadMode){
            //they are toggling ON; clear everything
            handleAttendeeFileReset();
        }

        setIsUploadMode(!isUploadMode);
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setSelectedFile(file);

        const reader = new FileReader();
        const fileType = file.name.split('.').pop().toLowerCase();

        if (fileType === 'csv') {
            // Handle CSV Parsing
            reader.onload = (e) => {
                const text = e.target.result;
                const parsedData = Papa.parse(text, { header: true });

                /*
                    if there isn't a column labeled as id then we need to male one and
                    populate it with just numbered data
                 */
                const dataWithIds = parsedData.data
                    .filter(row => Object.values(row).some(value => value !== '' && value !== null && value !== undefined)) // Filter out empty rows
                    .map((row, index) => {
                        const idValue = row.id || row.ID || row.Id || index; // Use existing id if it exists, otherwise use index
                        const displayId = index + 1;
                        return {
                            id: idValue,  // Ensure the `id` field is always present
                            displayId,
                            ...row  // Spread the rest of the row's data
                        };
                    });

                setFileDataWithIds(dataWithIds);

                setOriginalFileData(parsedData.data);  // Store the original data
                setColumns(Object.keys(parsedData.data[0]).map((key) => ({ field: key, headerName: key, width: 150 })));
            };
            reader.readAsText(file);
        } else if (fileType === 'xls' || fileType === 'xlsx') {
            // Handle XLS/X Parsing
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

                // First row is header
                const headers = sheet[0];
                const rows = sheet.slice(1).map((row) => {
                    const rowData = {};
                    headers.forEach((header, index) => {
                        rowData[header] = row[index];
                    });
                    return rowData;
                });

                const dataWithIds = rows
                    .filter(row => Object.values(row).some(value => value !== '' && value !== null && value !== undefined)) // Filter out empty rows
                    .map((row, index) => {
                        const idValue = row.id || row.ID || row.Id || index; // Use existing id if it exists, otherwise use index
                        const displayId = index + 1;
                        return {
                            id: idValue,  // Ensure the `id` field is always present
                            displayId,
                            ...row  // Spread the rest of the row's data
                        };
                    });

                setFileDataWithIds(dataWithIds);
                setOriginalFileData(rows);  // Store the original data
                setColumns(headers.map((header) => ({ field: header, headerName: header, width: 150 })));

            };
            reader.readAsArrayBuffer(file);
        } else {
            alert('Unsupported file format. Please upload a CSV or Excel file.');
        }
    };
    const highlightDuplicates = (duplicates) => {
        const updatedRows = fileDataWithIds.map((row) => {
            // Dynamically find the email field (case-insensitive check for 'email')
            const emailKey = Object.keys(row).find(key => key.toLowerCase().includes('email'));
            return {
                ...row,
                isDuplicate: duplicates.includes(row[emailKey]?.toLowerCase()) // Mark duplicates
            };
        });

        console.log("updatedRows: "+JSON.stringify(updatedRows));

        // Sort: move duplicates to the top
        const sortedData = updatedRows.sort((a, b) => {
            if (a.isDuplicate && !b.isDuplicate) return -1;
            if (!a.isDuplicate && b.isDuplicate) return 1;
            return 0;
        });

        // Update the grid data with sorted and marked rows (this updates dataWithIds)
        setFileDataWithIds(sortedData);  // Update the state for DataGrid to re-render
    };
    const handleButtonSubmit = () => {
        console.log("selectedEntries : ", selectedEntries);

        // Extract emails from the selectedEntries (case-insensitive lookup for any variation of 'email')
        const selectedEmails = selectedEntries.map((row) => {
            // Find a key that contains 'email' (case-insensitive)
            const emailKey = Object.keys(row).find(key => key.toLowerCase().includes('email'));
            // Return the email value if found, otherwise return null
            return row[emailKey]?.toLowerCase() || null;
        }).filter(Boolean);  // Filter out any null values

        // Extract emails from the Attendees array
        const attendeeEmails = Attendees.map((attendee) => attendee.email?.toLowerCase());

        // Find duplicates between selected emails and Attendees' emails
        const duplicates = selectedEmails.filter((email) => attendeeEmails.includes(email));
        console.log("duplicates : ", duplicates);

        // Show the alert if duplicates are found and highlight them
        if (duplicates.length > 0) {
            setDuplicateEmails(duplicates);  // Display duplicates as an alert or some other UI
            highlightDuplicates(duplicates); // Highlight duplicates in the DataGrid
        } else {
            setDuplicateEmails([]);  // Clear duplicates
            // Proceed with the upload logic if no duplicates
            console.log('No duplicates found. Proceeding with submission...');
        }
    };
    const handleAttendeeFileReset = () => {

        // Reset the file input to remove any selected file
        setSelectedFile(null);

        // Clear file data states to reset the uploaded data
        setFileDataWithIds([]); // If using dataWithIds as a processed version
        setColumns([]);

        // Clear duplicate alerts or state flags related to duplicates
        setDuplicateEmails([]);
        setSelectedEntries([]);

        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clear the displayed file name
        }

    }


    const [isMasterListsDialogOpen, setIsMasterListsDialogOpen] = useState(false);




    const [anchorAccountMenu, setAnchorAccountMenu] = useState(null);
    const handleAccountMenuOpenMenu = (event) => {
        setAnchorAccountMenu(event.currentTarget);
    };
    const handleAccountMenuClick = (event) => {
        console.log("handleAccountMenuClick");
        setAnchorAccountMenu(null);

    };
    const handleAccountMenuClose = () => {
        setAnchorAccountMenu(null);
    };
    const [anchorAccountMenuMobile, setAnchorAccountMenuMobile] = useState(null);
    const handleAccountMenuMobileOpenMenu = (event) => {
        setAnchorAccountMenuMobile(event.currentTarget);
    };
    const handleAccountMenuMobileClick = (event) => {
        console.log("setAnchorAccountMenuMobileClick");
        setAnchorAccountMenuMobile(null);

    };
    const handleAccountMenuMobileClose = () => {
        setAnchorAccountMenuMobile(null);
    };

    // Dynamically calculate the card width based on the dialog width
    const dialogRefEvent = useRef(null);
    const [dialogWidth, setDialogWidth] = useState(0);
    // Get the width of the Dialog once it's rendered
    useEffect(() => {
        if (isEventDialogOpen && dialogRefEvent.current) {
            const width = dialogRefEvent.current.offsetWidth;
            console.log("&&&&&&&& setting dialogWidth : "+width);
            setDialogWidth(width);
        }
    }, [isEventDialogOpen]);
    const calculateCardWidth = () => {
        const cardsPerRow = 3;  // You can adjust the number of cards per row here
        const spacing = 16;  // Space between cards (as defined by Grid spacing)
        const totalSpacing = (cardsPerRow - 1) * spacing;
        const calculatedWidth = (dialogWidth - totalSpacing) / cardsPerRow;

        // Handle cases where calculatedWidth is negative
        if (calculatedWidth <= 0) {
            return 250; // Minimum fallback width
        }

        // Ensure the card width does not exceed 250px
        return Math.min(calculatedWidth, 250);
    };


    const formatEventTime = (timeTable) => {
        if (!timeTable) return '';

        // Helper function to format the time (handle begin and end time)
        const formatTimeRange = (beginTime, endTime) => {
            const formattedBeginTime = dayjs(`2024-01-01 ${beginTime}`).format('hA');
            const formattedEndTime = endTime ? dayjs(`2024-01-01 ${endTime}`).format('hA') : '';
            return formattedEndTime ? `${formattedBeginTime} - ${formattedEndTime}` : formattedBeginTime;
        };

        // Function to format the date range
        const getDateRange = () => {
            const { dates } = timeTable;

            if (dates && dates.length > 0) {
                const beginDate = dayjs(dates[0].date);
                const endDate = dayjs(dates[dates.length - 1].date);

                if (beginDate.isSame(endDate, 'day')) {
                    // Same day with begin and end time
                    const beginTime = dates[0]['begin_time'] || '12:00 AM';
                    const endTime = dates[0]['end_time'] || '11:59 PM';
                    return `${beginDate.format('D MMM YYYY')} ${formatTimeRange(beginTime, endTime)}`;
                } else if (beginDate.isSame(endDate, 'year')) {
                    // Same year, different days
                    return `${beginDate.format('D MMM')} - ${endDate.format('D MMM YYYY')}`;
                } else {
                    // Different years
                    return `${beginDate.format('D MMM YYYY')} - ${endDate.format('D MMM YYYY')}`;
                }
            }
            return null;
        };

        // Function to format the days (if no dates exist)
        const getDaysRange = () => {
            const { days } = timeTable;

            if (days && days.length > 0) {
                const firstDay = days[0]['day 1'];
                const lastDay = days[days.length - 1][`day ${days.length}`];
                const dayCount = days.length;

                if (dayCount === 1 || firstDay === lastDay) {
                    return `1 Day ${firstDay}`; // Singular "Day"
                }

                return `${dayCount} Days ${firstDay} - ${lastDay}`; // Plural "Days"
            }
            return null;
        };

        // Return the event's date range or days as a formatted string
        const dateRange = getDateRange();
        const daysRange = getDaysRange();

        // Return either the date range or days range
        return dateRange || daysRange || '';
    };

    const [anchorAttendeeElements, setAnchorAttendeeElements] = useState(sortedAttendees.map(() => null));
    const handleOpenAttendeeMenu = (event, index) => {
        const updatedAnchors = [...anchorAttendeeElements];
        updatedAnchors[index] = event.currentTarget;
        setAnchorAttendeeElements(updatedAnchors);
    };

    // Function to handle closing the menu for a specific attendee.
    const handleCloseAttendeeMenu = (index) => {
        const updatedAnchors = [...anchorAttendeeElements];
        updatedAnchors[index] = null;
        setAnchorAttendeeElements(updatedAnchors);
    };


    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [attendeeToDeleteId, setAttendeeToDeleteId] = useState("");
    const [attendeeToDeleteName, setAttendeeToDeleteName] = useState("");

    function handleDialogDeleteOpen(index, attendee_id) {
        console.log("handleDialogDeleteOpen : "+attendee_id);

        handleCloseAttendeeMenu(index);

        setAttendeeToDeleteId(attendee_id);

        const foundAttendee = Attendees.find((_att) => _att.id === attendee_id);
        setAttendeeToDeleteName(foundAttendee.fname + ' ' + foundAttendee.lname);

        setOpenDialogDelete(true);

    }
    function handleDialogDeleteClose() {
        setOpenDialogDelete(false);
    }
    function handleDialogDeleteOK(){
        setOpenDialogDelete(false);

        const _new_event = new PAEvent();
        _new_event.title = "My New Event";
        _new_event.status = 10;

        //see if they are logged in
        if (Object.keys(Account).length === 0){
            //create the default Planner Attendee
            console.log("Need to create the default Planner Attendee");
            const _planner = new PAAttendee(
                'Sample',
                'Planning',
                'sample.planning@example.com');
            _planner.id = "100000";
            _planner.role = 'admin';
            _planner.planner = false;
            _planner.nickname = 'Planner';
            _planner.isSample = true;
            _new_event.attendees.push(_planner);

            //add them to the host array
            _new_event.host = [_planner.id];

            setAccount(_planner);
        } else {
            //they are logged in so use their account
            console.log("User is logged in");

            const _planner = new PAAttendee(
                Account.fname,
                Account.lname,
                Account.email);
            _planner.id = Account.id;
            _planner.created = Account.created;
            _planner.role = Account.role;
            _planner.nickname = Account.nickname;
            _planner.language = Account.language;
            _planner.avatar = Account.avatar;
            _planner.preferred_airport = Account.preferred_airport;

            _planner.address = Account.address;
            _planner.city = Account.city;
            _planner.state = Account.state;
            _planner.zip = Account.zip;
            _planner.country = Account.country;

            _planner.email = Account.email;
            _planner.dob = Account.dob;

            _planner.phone_prefix = Account.phone_prefix;
            _planner.phone = Account.phone;
            _planner.mask_phone_number = Account.mask_phone_number;

            _planner.events = Account.events;
            _planner.documents = Account.documents;

            _new_event.attendees.push(_planner);

            //add them to the host array
            _new_event.host = [Account.id];

        }

        console.log("_new_event", _new_event);

        set_PA_GlobalObject({ Planning: _new_event });
    }


    const [selectedImage, setSelectedImage] = useState(""); // Initial image

    // Function to handle file input click on avatar
    const handleAvatarClick = (id) => {
        document.getElementById(`file-input-${id}`).click();
    };

    // Function to handle file change and set the image
    const handleImageChange = (event, id) => {
        const file = event.target.files[0];

        console.log("file : "+file);

        if (file) {
            const imageUrl = URL.createObjectURL(file); // Create a URL for the selected image


            // Optionally save the file to the attendee's profile
            setSortedAttendees(prevAttendees =>
                prevAttendees.map(attendee =>
                    attendee.id === id
                        ? { ...attendee, image: imageUrl } // Update the image for the matched attendee
                        : attendee
                )
            );
        }
    };



    const [groupedAttendees, setGroupedAttendees] = useState([]); // State to hold grouped attendees

    // Toggle attendee in and out of the group array
    const handleGroupToggle = (attendeeId) => {
        setGroupedAttendees(prevGrouped =>
            prevGrouped.includes(attendeeId)
                ? prevGrouped.filter(id => id !== attendeeId) // Remove if already in group
                : [...prevGrouped, attendeeId] // Add if not in group
        );
    };

    const [isGettingStartedDialogOpen, setGettingStartedDialogOpen] = useState(false);


    const MotionSlider = ({ images }) => {
        const [current, setCurrent] = useState(0);

        useEffect(() => {
            if (images.length <= 1) return;
            const timer = setInterval(() => {
                setCurrent(prev => (prev + 1) % images.length);
            }, 4000); // 4 seconds is usually better for reading captions/eyes to adjust
            return () => clearInterval(timer);
        }, [images.length]); // Only reset timer if the count changes

        return (
            <Box sx={{ overflow: 'hidden', height: '250px', position: 'relative', borderRadius: '16px', bgcolor: '#f8f9fa' }}>
                <AnimatePresence mode="wait">
                    <motion.img
                        key={`slide-${current}`}
                        src={images[current]}
                        initial={{ opacity: 0, scale: 1.1 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8 }}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            position: 'absolute'
                        }}
                    />
                </AnimatePresence>
            </Box>
        );
    };

    const handleCreateNewEventClick = () => {
        console.log("Create New Event clicked!");
        setExpandedAccordions(prev => prev.filter(panel => panel !== 'eventList')); // Close accordion
        handleAccountMenuMobileClose(); // Close menu
    };

    const EventCard = ({ event, accountId, onClick, width }) => {
        // 1. Get ALL photos marked for the album (Group View)
        const photoAlbumImages = useMemo(() => {
            return (event.photos || [])
                .filter(photo =>
                    photo.photo_album === true &&
                    (photo.attendee_id === accountId || !photo.private)
                )
                .map(photo => {
                    if (photo.signed_url) return photo.signed_url;
                    if (photo.full_data) return photo.full_data;
                    if (photo.thumbnail_data) return photo.thumbnail_data;
                    return null;
                })
                .filter(url => url !== null);
        }, [event.photos, accountId]);

        const hasAlbum = photoAlbumImages.length > 0;

        // 2. The "Waterfall" Cover Image Selection
        const eventCover = useMemo(() => {
            if (event.coverImage?.full?.full_data) return event.coverImage.full.full_data;
            if (event.coverImage?.thumbnail?.thumbnail_data) return event.coverImage.thumbnail.thumbnail_data;
            if (event.cover_image_full_data) return event.cover_image_full_data;
            if (event.cover_image_thumbnail) return event.cover_image_thumbnail;
            return "https://plannedadventure.com/assets/images/user_bg1.png";
        }, [event.coverImage, event.cover_image_full_data, event.cover_image_thumbnail]);

        return (
            <Card
                onClick={() => onClick(event.id)}
                sx={{
                    cursor: 'pointer',
                    width,
                    // 🟢 FIXED: Clamp every single card row to an identical uniform height profile
                    height: 84,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    boxShadow: 2,
                    borderRadius: 2,
                    overflow: 'hidden',
                    mb: 1
                }}
            >
                {/* Left Box Column Area: Image Displays with Cascade Priority Logic */}
                {hasAlbum ? (
                    // Priority 1: User Shared Slideshow Album
                    <Box sx={{
                        width: 80,
                        height: '100%', // 🟢 FIXED: Lock explicit vertical space container bounds
                        overflow: 'hidden',
                        position: 'relative', // 🟢 VITAL: Gives MotionSlider a layout target anchor anchor point
                        display: 'block',
                        '& img': {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        },
                        // Force the actual slider component to fill the dimension matrix
                        '& > div': {
                            width: '100%',
                            height: '100%'
                        }
                    }}>
                        <MotionSlider images={photoAlbumImages} />
                    </Box>
                ) : (event.coverImage || event.cover_image_thumbnail) ? (
                    // Priority 2: Explicitly Set Event Cover Image
                    <CardMedia
                        component="img"
                        image={eventCover}
                        sx={{
                            width: 80,
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                ) : (
                    // Priority 3: Default Hard Fallback Placeholder Asset
                    <CardMedia
                        component="img"
                        image="https://plannedadventure.com/assets/images/user_bg1.png"
                        sx={{
                            width: 80,
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                )}

                {/* Right Side Column Area: Text content */}
                <CardContent sx={{
                    padding: '8px 12px',
                    '&:last-child': { paddingBottom: '8px' },
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    overflow: 'hidden'
                }}>
                    <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        sx={{
                            fontSize: '0.95rem',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%',
                        }}
                    >
                        {event.title}
                    </Typography>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                            fontSize: '0.75rem',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%',
                            mt: 0.5
                        }}
                    >
                        {formatEventTime(event.time_table)}
                    </Typography>
                </CardContent>
            </Card>
        );
    };


    //for the Master Calendar menu item
    const [masterCalendarDialogOpen, setMasterCalendarDialogOpen] = useState(false);
    const handleMasterCalendarOpen = () => setMasterCalendarDialogOpen(true);
    const handleMasterCalendarClose = () => setMasterCalendarDialogOpen(false);


    //for the To Do menu item
    const [todoDialogOpen, setTodoDialogOpen] = useState(false);
    const handleToDoOpen = () => setTodoDialogOpen(true);
    const handleToDoClose = () => setTodoDialogOpen(false);
    // Optional: Compute total number of To Do items for the current user
    const [toDoItems, setToDoItems] = useState([]);
    const [totalToDos, setTotalToDos] = useState(0);


    const [expandedAccordions, setExpandedAccordions] = useState([]);
    const handleAccordionChange = (panel) => (event, isExpanded) => {

        console.log("handleAccordionChange : ", panel);

        setExpandedAccordions(prev => {
            if (isExpanded) {
                return [...prev, panel];
            } else {
                return prev.filter(p => p !== panel);
            }
        });

        if (panel === 'eventList' && isExpanded){
            //make sure any existing events are listed
            getAllEventsFromDatabase(Account.id).then((_events) => {
                console.log("back from the database : ", _events);

                if (_events) {
                    const sorted = [..._events].sort((a, b) => {
                        const hasDatesA = a.time_table?.dates?.length > 0;
                        const hasDatesB = b.time_table?.dates?.length > 0;
                        const hasDaysA = a.time_table?.days?.length > 0;
                        const hasDaysB = b.time_table?.days?.length > 0;

                        // Prioritize events with empty dates/days first
                        if (!hasDatesA && !hasDaysA && (hasDatesB || hasDaysB)) return -1;
                        if (!hasDatesB && !hasDaysB && (hasDatesA || hasDaysA)) return 1;

                        // If both have dates, sort by the first available date
                        if (hasDatesA && hasDatesB) {
                            const dateA = dayjs(a.time_table.dates[0].date);
                            const dateB = dayjs(b.time_table.dates[0].date);
                            return dateA.isBefore(dateB) ? 1 : -1;
                        }

                        // If both have empty dates/days, sort alphabetically by title
                        return (a.title || "").localeCompare(b.title || "");
                    });

                    console.log("sorted Events length : " + sorted.length);
                    setSortedEvents(sorted);
                }
            });
        }
    };

    // Styles for menu items
    const listItemSx = {
        mb: 0.5,
        transition: 'background-color 0.2s ease-in-out',
    };
    const listItemTopLevelIconSx = {
        minWidth: '40px',
        color: '#10318f',
        fontSize:  '22px'
    };
    const listItemTopLevelTextSx = {
        fontWeight: 500,
        color: '#10318f',
        fontSize: '16px'
    };
    const listItemIconSx = {
        minWidth: '40px',
        color: '#10318f',
        fontSize:  '18px'
    };
    const listItemTextSx = {
        fontWeight: 500,
        color: '#10318f',
        fontSize: '14px'
    };


    const accordionSummarySx = {
        backgroundColor: '#fff', // Make background white
        borderRadius: '0',
        boxShadow: 'none', // Remove shadow
        border: 'none', // Remove border
        '&.Mui-expanded': {
            backgroundColor: 'transparent', // Ensure transparent when expanded
        },
    };

    // Modified accordion details styles to be plain
    const accordionDetailsSx = {
        backgroundColor: 'rgb(241, 241, 241)', // Make background light gray
        borderRadius: '0', // Keep some rounding if desired, or set to 0
        border: 'none', // Remove border
        py: 0, // Remove vertical padding
        px: 2, // Remove horizontal padding
        // New styles for scrolling content
        maxHeight: '400px', // Set a max height for the scrollable area
        overflowY: 'auto',   // Enable vertical scrolling when content overflows
        // Optional: Add custom scrollbar styling for better aesthetics
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#bdbdbd',
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        },
    };

    // Helper for rendering menu items
    const renderMenuItem = (text, icon, onClickAction = null, subText = null) => (
        <ListItem key={text} disablePadding sx={listItemSx}>
            <ListItemButton onClick={() => {
                console.log(`Clicked: ${text}`);
                if (onClickAction) onClickAction(); // Execute the provided action first
//                handleDrawerToggle(); // Then close the drawer
            }}>
                <ListItemIcon sx={listItemIconSx}>{icon}</ListItemIcon>
                <ListItemText
                    primary={<Typography sx={listItemTextSx}>{text}</Typography>}
                    secondary={subText && <Typography variant="caption" color="text.secondary">{subText}</Typography>}
                />
            </ListItemButton>
        </ListItem>
    );

    // Navigation items for non-authenticated users
    const publicNavItems = (
        <List>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-home" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTextSx}>Home</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-info-circle" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTextSx}>Features</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-wallet" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTextSx}>Pricing</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-envelope" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTextSx}>Contact Us</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-files2" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTextSx}>Templates</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-compass" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTextSx}>Planner</Typography>}
                    />
                </ListItemButton>
            </ListItem>

            {/* Event Features Section */}
            <Accordion
                expanded={expandedAccordions.includes('eventFeatures')}
                onChange={handleAccordionChange('eventFeatures')}
                sx={accordionSummarySx}
            >
                <AccordionSummary
                    expandIcon={<i className='icon-chevron-down' />}
                    aria-controls="event-features-content"
                    id="event-features-header"
                >
                    <ListItemIcon sx={listItemIconSx}><i className="icon-helm"/></ListItemIcon>
                    <Typography sx={listItemTextSx}>Planner Features</Typography>
                </AccordionSummary>
                <AccordionDetails sx={accordionDetailsSx}>
                    <List disablePadding dense>
                        {/* the SAVE item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Save')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-floppy-disk" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>SAVE</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the EVENT POINTS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Points')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-trophy" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Reward Points</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the ITINERARY item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Itinerary')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-calendar" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Itinerary</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the MAP item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Map')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-map" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Map</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the COVER item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Details')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-settings-icons" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Cover</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the DATES/DAYS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Dates')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-calendar3" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Dates/Days</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the BUDGET item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Budget')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-wallet" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Budget</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the NOTES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Notes')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-notebook" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Notes</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the DOCUMENT item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Documents')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-file-lock" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Documents</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the ACTIVITIES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Activities')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-list-heart" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Activities</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the IDEAS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Ideas')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-lamp-bright" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Ideas</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the ATTENDEES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Attendees')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-group" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Attendees</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the LODGING item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Lodging')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-bed" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Lodging</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the FLIGHTS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Flights')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-airplane" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Flights</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the MESSAGES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Messages')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-smartphone-text" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Messages</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the MEALS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Meals')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-fork-knife2" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Meals</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the PHOTOS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Photos')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-picture2" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Photos</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the SUPPLIES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Supplies')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-checklist2" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Supplies</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the RECEIPTS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Receipts')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-receipt" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Receipts</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the TODO item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Todo')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-checklist-time" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>To-Do</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the WEATHER item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Weather')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-sun-wind" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Weather</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the CLEAR item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Clear')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-trash" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Clear</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </AccordionDetails>
            </Accordion>
            {/* Login button moved inside publicNavItems */}
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemIconSx}><i className="icon-enter" /></ListItemIcon>
                    <ListItemText primary={<Typography sx={listItemTextSx}>Login</Typography>} />
                </ListItemButton>
            </ListItem>
        </List>
    );

    //for showing/hiding the Concierge messaging window
    function handleShowConciergeWindow(){
        //toggle the show/hide
        setShowConciergeServiceWindow(!showConciergeServiceWindow);
    }

    //for the Analyzer menu item
    const [showAnalyzer, setShowAnalyzer] = useState(false);
    const handleRunAnalyzer = () => {
        setShowAnalyzer(true); // open the dialog
    };

    // Navigation items for authenticated users

    const [anchorEl, setAnchorEl] = useState(null);
    const [expanded, setExpanded] = useState('none');

    // Modern UI Styles
    const styles = {
        menuPaper: {
            width: 320,
            maxHeight: '90vh',
            backgroundColor: '#ffffff',
            borderRadius: '24px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            overflowY: 'auto',
            padding: '8px 0',
            '&::-webkit-scrollbar': { width: '4px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#e2e8f0', borderRadius: '10px' },
        },
        adventureCard: {
            position: 'relative',
            padding: '10px',
            backgroundColor: 'rgba(198, 226, 255, 0.7)',
            backdropFilter: 'blur(15px)',
            borderRadius: '10px',
            color: '#1e293b',
            overflow: 'hidden',
            boxShadow: '0 4px 20px -5px rgba(0, 0, 0, 0.05)',
            cursor: 'pointer',
            '&:hover .trophy-icon': {
                transform: 'scale(1.1) rotate(5deg)',
            }
        },

        sectionLabel: {
            px: 3,
            pt: 2,
            pb: 0.5,
            fontSize: '0.65rem',
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            color: '#94a3b8',
        },
        listItem: {
            mx: 1.5,
            my: 0.5,
            borderRadius: '12px',
            '&:hover': {
                backgroundColor: '#f8fafc',
                '& .icon-box': { backgroundColor: '#fff', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }
            },
        },
        iconBox: (color = '#64748b') => ({
            className: 'icon-box',
            minWidth: '36px',
            height: '36px',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 2,
            backgroundColor: '#f1f5f9',
            color: color,
            transition: 'all 0.2s ease',
            fontSize: '1.1rem',
        }),
        accordion: {
            background: 'transparent',
            boxShadow: 'none',
            mx: '12px !important',
            '&:before': { display: 'none' },
            '&.Mui-expanded': { my: '4px !important' }
        },
        conciergeDetail: {
            ml: 5,
            mr: 1,
            borderRadius: '10px',
            '&:hover': { backgroundColor: '#f1f5f9' }
        }
    };
    const NavItem = ({ icon, label, color, onClick, secondary }) => (
        <ListItem disablePadding sx={styles.listItem}>
            <ListItemButton onClick={onClick} sx={{ borderRadius: '12px', py: 1 }}>
                <Box sx={styles.iconBox(color)}>
                    <i className={icon} />
                </Box>
                <ListItemText
                    primary={<Typography sx={{ fontWeight: 600, fontSize: '0.9rem', color: '#1e293b' }}>{label}</Typography>}
                    secondary={secondary && <Typography sx={{ fontSize: '0.7rem', color: '#64748b' }}>{secondary}</Typography>}
                />
            </ListItemButton>
        </ListItem>
    );
    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleAccordion = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : 'none');
    };



    const authenticatedDesktopNavItems = (
        <List sx={{position:'static', paddingTop: 0}}>

            {/* LIGHTER ENHANCED POINTS SECTION */}
            <Box
                sx={styles.adventureCard}
                onClick={() => {
                    setAccountPointsDialogOpen(true);
                    // 2. Close the Menu anchors
                    setAnchorAccountMenu(false);
                    setAnchorAccountMenuMobile(false);
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Box>
                        <Typography sx={{ fontSize: '0.65rem', fontWeight: 900, letterSpacing: '0.1em', color: '#10318f', mb: 0.5 }}>
                            ADVENTURE STATUS
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 900, color: '#1e293b', lineHeight: 1 }}>
                            {loadingEvents ? '...' : `${runningScoreTotal} Points`}
                        </Typography>
                        <Typography sx={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 500 }}>
                            Yearly Points
                        </Typography>
                    </Box>
                    <Box className="trophy-icon" sx={{ transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)' }}>
                        <i className="icon-trophy" style={{ fontSize: '3rem', color: '#10318f', filter: 'drop-shadow(0 4px 6px rgba(251, 191, 36, 0.3))' }} />
                    </Box>
                </Box>

                <Box sx={styles.progressContainer}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mb: 0.5 }}>
                        <Typography sx={{ fontSize: '0.7rem', fontWeight: 800, color: '#1e293b' }}>
                            {isMaxTier ? 'Milestone Complete' : 'Level Progress'}
                        </Typography>
                        <Typography sx={{ fontSize: '0.7rem', fontWeight: 800, color: '#10318f' }}>
                            {Math.round(progress)}%
                        </Typography>
                    </Box>
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: 'rgba(0,0,0,0.05)',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: '#10318f',
                                borderRadius: 3,
                            }
                        }}
                    />
                    <Typography sx={{ fontSize: '0.65rem', mt: 0.5, color: '#677383', textAlign: 'left', fontWeight: 600 }}>
                        {isMaxTier ? (
                            <span style={{ color: '#16a34a', fontWeight: 700 }}>★ Max Tier Reached!</span>
                        ) : (
                            `${ptsToNextMilestone.toLocaleString()} pts to next milestone`
                        )}
                    </Typography>
                </Box>
            </Box>

            {/* SECTION 1: PLANNING TOOLS */}
            <Typography sx={styles.sectionLabel}>Tools & Account</Typography>
            <List disablePadding>
                <NavItem icon="icon-calendar2" label="Calendar" color="#3b82f6" secondary="Schedule & Bookings"
                         onClick={() => {
                             // 1. Open the Dialog
                             setMasterCalendarDialogOpen(true);

                             // 2. Close the Menu anchors
                             setAnchorAccountMenu(false);
                             setAnchorAccountMenuMobile(false);
                         }}
                />
                <NavItem icon="icon-checklist-time" label="To-Do" color="#10b981" secondary="Tasks & Supplies"
                         onClick={() => {
                             // 1. Open the Dialog
                             setTodoDialogOpen(true);

                             // 2. Close the Menu anchors
                             setAnchorAccountMenu(false);
                             setAnchorAccountMenuMobile(false);
                         }}
                />
                <NavItem icon="icon-user" label="Account" color="#6366f1" secondary="Profile & Settings"
                         onClick={() => {
                             // 1. Open the Dialog
                             setShowAccountDialog(true)

                             // 2. Close the Menu anchors
                             setAnchorAccountMenu(false);
                             setAnchorAccountMenuMobile(false);
                         }}
                />
            </List>

            <Divider sx={{ my: 1, mx: 3, opacity: 0.6 }} />

            {/* SECTION 2: CONCIERGE */}
            <Accordion expanded={expanded === 'concierge'} onChange={handleAccordion('concierge')} sx={styles.accordion}>
                <AccordionSummary expandIcon={<i className="icon-chevron-down" style={{ fontSize: '0.8rem'}} />}>
                    <Box sx={styles.iconBox('#f43f5e')}>
                        <i className="icon-robot" />
                    </Box>
                    <Box sx={{ py: 0.5 }}>
                        <Typography sx={{ fontWeight: 700, fontSize: '0.9rem' }}>Concierge</Typography>
                        <Typography sx={{ fontSize: '0.7rem', color: '#64748b' }}>AI Travel Assistant</Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 0, pb: 1 }}>
                    <ListItemButton sx={styles.conciergeDetail} onClick={handleShowConciergeWindow}>
                        <ListItemIcon sx={{ minWidth: 32 }}><i className="icon-bathtub" style={{ color: '#f43f5e' }} /></ListItemIcon>
                        <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>Messaging</Typography>} />
                    </ListItemButton>
                    <ListItemButton sx={styles.conciergeDetail} onClick={handleRunAnalyzer}>
                        <ListItemIcon sx={{ minWidth: 32 }}><i className="icon-bathtub" style={{ color: '#f43f5e' }} /></ListItemIcon>
                        <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>Analyzer</Typography>} />
                    </ListItemButton>
                </AccordionDetails>
            </Accordion>

            <Divider sx={{ my: 1, mx: 3, opacity: 0.6 }} />

            {/* SECTION 3: PUBLIC FACING */}
            <Typography sx={styles.sectionLabel}>Our Service</Typography>
            <List disablePadding>
                <NavItem icon="icon-info-circle" label="Features" onClick={onButtonClick} />
                <NavItem icon="icon-wallet" label="Pricing" onClick={onButtonClick} />
                <NavItem icon="icon-envelope" label="Contact Us" onClick={onButtonClick} />
            </List>

            <Divider sx={{ my: 1.5 }} />

            {/* LOGOUT */}
            <ListItemButton
                onClick={() => {
                    handleAccountMenuMobileClick('logout')
                }}
                sx={{ mx: 2, borderRadius: '12px', mb: 1, color: '#ef4444', '&:hover': { backgroundColor: '#fef2f2' }}}
            >
                <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
                    <i className="icon-enter" style={{ fontSize: '1.2rem', transform: 'rotate(180deg)' }} />
                </ListItemIcon>
                <ListItemText primary={<Typography sx={{ fontWeight: 700, fontSize: '0.9rem' }}>Logout</Typography>} />
            </ListItemButton>
        </List>
    );

    const authenticatedNavItems = (
        <List sx={{position:'static', padding: 1}}>

            {/* Account Points Visual - TOP ITEM */}
            <ListItem disablePadding sx={{ width: '100%', mb: 1.5 }}>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row', // Changed to row for horizontal layout
                        alignItems: 'center', // Vertically align items in the row
                        justifyContent: 'space-between', // Space out trophy and text block
                        overflow: 'hidden',
                        height: '90px', // Fixed height
                    }}
                    onClick={() => setAccountPointsDialogOpen(true)}
                >
                    {/* Left side: Trophy Icon */}
                    <Box sx={{ p: 1 }}> {/* Added padding around icon for spacing */}
                        <i
                            className="icon-trophy"
                            style={{
                                fontSize: '2.5rem',
                                color: '#f5b042',
                                lineHeight: 1,
                                filter: 'drop-shadow(1px 1px 1px rgba(0,0,0,0.2))'
                            }}
                        />
                    </Box>

                    {/* Right side: Text and Progress Bar */}
                    <Box sx={{ flexGrow: 1, textAlign: 'right', pr: 1 }}> {/* Right align text, padding right */}
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#333', lineHeight: 1, mb: 0.25 }}>
                            Your Adventures:
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700, color: '#673ab7', textShadow: '1px 1px 2px rgba(0,0,0,0.1)', lineHeight: 1.2, mb: 0.25 }}>
                            {yearlyPoints + totalAccountPoints} Points
                        </Typography>
                    </Box>
                </Box>
            </ListItem>

            {/* Event List Section */}
            <Accordion
                expanded={expandedAccordions.includes('eventList')}
                onChange={handleAccordionChange('eventList')}
                sx={accordionSummarySx}
            >
                <AccordionSummary
                    expandIcon={<i className='icon-chevron-down' />}
                    aria-controls="event-list-content"
                    id="event-list-header"
                >
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-calendar"/></ListItemIcon>
                    <Typography sx={listItemTopLevelTextSx}>Events</Typography>
                </AccordionSummary>
                <AccordionDetails sx={accordionDetailsSx}>
                    <List disablePadding dense>
                        {/* put the option here for creating a new Event */}
                        <ListItem
                            disablePadding
                            sx={{
                                borderRadius: '5px',
                                mb: 1,
                                mt: 1,
                                background: 'linear-gradient(135deg, #e0f7fa, #f1f8e9)',
                                boxShadow: '0 3px 10px rgba(0,0,0,0.06)',
                                transition: 'all 0.25s ease',
                                '&:hover': {
                                    boxShadow: '0 6px 14px rgba(0,0,0,0.12)',
                                    transform: 'translateY(-2px)',
                                    cursor: 'pointer',
                                }
                            }}
                        >
                            <ListItemButton onClick={handleCreateNewEventClick}>
                                <ListItemIcon sx={{ minWidth: 48 }}>
                                    <Box
                                        sx={{
                                            backgroundColor: '#4caf50',
                                            color: '#fff',
                                            borderRadius: '10px',
                                            width: 36,
                                            height: 36,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '18px',
                                            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
                                        }}
                                    >
                                        📆
                                    </Box>
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#2e7d32' }}>
                                            Create New Event
                                        </Typography>
                                    }
                                    secondary={
                                        <Typography variant="caption" color="textSecondary">
                                            Plan something exciting — your way!
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>

                        {/* now list all of the Users Events */}
                        {
                            sortedEvents.length > 0 ? (
                                <List disablePadding dense>
                                    {sortedEvents.map((_event) => {
                                        // 1. Check if this specific list item is the one being edited in the Planner
                                        const isActive = PA_GlobalObject?.Planning?.id === _event.id;

                                        // 2. Override the stale _event with the live Planning object if IDs match
                                        const eventData = isActive ? PA_GlobalObject.Planning : _event;

                                        return (
                                            <EventCard
                                                key={_event.id}
                                                event={eventData} // Now this card gets the updated coverImage instantly
                                                accountId={Account.id}
                                                onClick={handleEventMenuClick}
                                            />
                                        );
                                    })}
                                </List>
                            ) : (
                                <ListItem>
                                    <ListItemText primary={<Typography sx={listItemTextSx}>No events found.</Typography>} />
                                </ListItem>
                            )
                        }
                    </List>
                </AccordionDetails>
            </Accordion>

            {/* Event Features Section */}
            <Accordion
                expanded={expandedAccordions.includes('eventFeatures')}
                onChange={handleAccordionChange('eventFeatures')}
                sx={accordionSummarySx}
            >
                <AccordionSummary
                    expandIcon={<i className='icon-chevron-down' />}
                    aria-controls="event-features-content"
                    id="event-features-header"
                >
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-helm"/></ListItemIcon>
                    <Typography sx={listItemTopLevelTextSx}>Event Features</Typography>
                </AccordionSummary>
                <AccordionDetails sx={accordionDetailsSx}>
                    <List disablePadding dense>
                        {/* the SAVE item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Save')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-floppy-disk" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>SAVE</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the EVENT POINTS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Points')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-trophy" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Reward Points</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the ITINERARY item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Itinerary')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-calendar" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Itinerary</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the MAP item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Map')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-map" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Map</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the COVER item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Details')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-settings-icons" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Cover</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the DATES/DAYS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Dates')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-calendar3" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Dates/Days</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the BUDGET item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Budget')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-wallet" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Budget</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the NOTES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Notes')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-notebook" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Notes</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the DOCUMENT item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Documents')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-file-lock" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Documents</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the ACTIVITIES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Activities')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-list-heart" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Activities</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the IDEAS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Ideas')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-lamp-bright" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Ideas</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the ATTENDEES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Attendees')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-group" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Attendees</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the LODGING item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Lodging')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-bed" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Lodging</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the FLIGHTS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Flights')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-airplane" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Flights</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the MESSAGES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Messages')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-smartphone-text" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Messages</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the MEALS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Meals')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-fork-knife2" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Meals</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the PHOTOS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Photos')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-picture2" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Photos</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the SUPPLIES item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Supplies')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-checklist2" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Supplies</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the RECEIPTS item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Receipts')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-receipt" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Receipts</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the TODO item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Todo')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-checklist-time" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>To-Do</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                        {/* the WEATHER item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={() => handleEventFeaturesMenuClick('Weather')}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-sun-wind" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Weather</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </AccordionDetails>
            </Accordion>

            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={handleMasterCalendarOpen}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-calendar2" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Calendar</Typography>}
                    />
                </ListItemButton>
            </ListItem>

            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={handleToDoOpen}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-checklist-time" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>To - Do</Typography>}
                    />
                </ListItemButton>
            </ListItem>

            {/* the ACCOUNT item */}
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={() => setShowAccountDialog(!showAccountDialog)}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-user" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Account</Typography>}
                    />
                </ListItemButton>
            </ListItem>

            {/* the ADMIN item */}
            {
                Account.role === 'master_admin' ? (
                    <ListItem disablePadding sx={listItemSx}>
                        <ListItemButton>
                            <ListItemIcon sx={listItemIconSx}><i className="icon-bell-ringing" /></ListItemIcon>
                            <ListItemText
                                primary={<Typography sx={listItemTextSx}>Admin Dashboard</Typography>}
                            />
                        </ListItemButton>
                    </ListItem>
                ) : null
            }


            {/* Concierge Section */}
            <Accordion
                expanded={expandedAccordions.includes('concierge')}
                onChange={handleAccordionChange('concierge')}
                sx={accordionSummarySx}
            >
                <AccordionSummary
                    expandIcon={<i className='icon-chevron-down' />}
                    aria-controls="concierge-content"
                    id="concierge-header"
                >
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-robot"/></ListItemIcon>
                    <Typography sx={listItemTopLevelTextSx}>Concierge</Typography>
                </AccordionSummary>
                <AccordionDetails sx={accordionDetailsSx}>
                    <List disablePadding dense>

                        {/* the ANALYZER item */}
                        <ListItem disablePadding sx={listItemSx}>
                            <ListItemButton onClick={handleRunAnalyzer}>
                                <ListItemIcon sx={listItemIconSx}><i className="icon-bathtub" /></ListItemIcon>
                                <ListItemText
                                    primary={<Typography sx={listItemTextSx}>Analyzer</Typography>}
                                />
                            </ListItemButton>
                        </ListItem>

                        {/* the LIST ITEMS item */}
                        {

                        }

                    </List>
                </AccordionDetails>
            </Accordion>

            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-compass" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Planner</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-files2" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Templates</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-info-circle" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Features</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-wallet" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Pricing</Typography>}
                    />
                </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={onButtonClick}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-envelope" /></ListItemIcon>
                    <ListItemText
                        primary={<Typography sx={listItemTopLevelTextSx}>Contact Us</Typography>}
                    />
                </ListItemButton>
            </ListItem>





            {/* Display Toggle */}
            <FormControlLabel
                control={
                    <Switch
                        checked={showHeader}
                        onChange={(e) => setShowHeader(e.target.checked)}
                        name="showHeaderToggle"
                        color="primary"
                        icon={<VisibilityOffIcon sx={{ color: '#757575' }} />}
                        checkedIcon={<VisibilityIcon sx={{ color: '#673ab7' }} />}
                    />
                }
                label={<Typography sx={listItemTextSx}>Display: {showHeader ? 'Show Header' : 'Hide Header'}</Typography>}
                sx={{ ml: 1, py: 1 }}
            />




            {/* Logout button moved inside authenticatedNavItems */}
            <ListItem disablePadding sx={listItemSx}>
                <ListItemButton onClick={() => {
                    handleAccountMenuMobileClick('logout')
                }}>
                    <ListItemIcon sx={listItemTopLevelIconSx}><LogoutIcon /></ListItemIcon>
                    <ListItemText primary={<Typography sx={listItemTopLevelTextSx}>Logout</Typography>} />
                </ListItemButton>
            </ListItem>
        </List>
    );

    const handleEventFeaturesMenuClick = (featureName) => {
        // Handle the click event here
        console.log(`Clicked on ${featureName}`);

        // Close the main drawer - but this doesn't close the Accordion section
        // to make it easier when going back to select different features
        handleAccountMenuMobileClose();

        switch (featureName){
            case "Login":
                setIsModalOpen(true);
                break;
            case "Points":
                setEventPointsDialogOpen(!eventPointsDialogOpen);
                break;
            case "Budget":
                setIsUnifiedBudgetDialogOpen(!isUnifiedBudgetDialogOpen);
                break;
            case "Save":
                setIsSavePlanningDialogOpen(!isSavePlanningDialogOpen);
                break;
            case "Concierge":
                navigate('/Planner/Concierge')
                break;
            case "Overview":
                navigate('/Planner/Overview')
                break;
            case "Details":
                navigate('/Planner/Details')
                break;
            case "Notes":
                navigate('/Planner/Notes')
                break;
            case "Location":
                navigate('/Planner/Location')
                break;
            case "Dates":
                navigate('/Planner/Dates')
                break;
            case "Map":
                navigate('/Planner/MapMobile')
                break;
            case "Itinerary":
                navigate('/Planner/Itinerary')
                break;
            case "Documents":
                navigate('/Planner/Documents')
                break;
            case "Activities":
                navigate('/Planner/Activities')
                break;
            case "Ideas":
                navigate('/Planner/Ideas')
                break;
            case "Attendees":
                navigate('/Planner/Attendees')
                break;
            case "Lodging":
                navigate('/Planner/Lodging')
                break;
            case "Flights":
                navigate('/Planner/Flights')
                break;
            case "carRentals":
                navigate('/Planner/CarRentals')
                break;
            case "Cruises":
                navigate('/Planner/Cruises')
                break;
            case "Messages":
                navigate('/Planner/Messages')
                break;
            case "Meals":
                navigate('/Planner/Meals')
                break;
            case "Photos":
                navigate('/Planner/Photos')
                break;
            case "Supplies":
                navigate('/Planner/Supplies')
                break;
            case "Receipts":
                navigate('/Planner/Receipts')
                break;
            case "Todo":
            case "To-Do":
                navigate('/Planner/Todo')
                break;
            case "Weather":
                navigate('/Planner/Weather')
                break;
            case "Clear":
                clearPlanning();
                break;
            default:
        }
    }

    //for the Budget Dialog
    const [isUnifiedBudgetDialogOpen, setIsUnifiedBudgetDialogOpen] = useState(false);

    //for the SAVE Dialog
    const [isSavePlanningDialogOpen, setIsSavePlanningDialogOpen] = useState(false);

    function clearPlanning(){
        //show the prompt
        setOpenDialogDelete(true);

    }





    const themeNew = {
        primary: '#2563eb',
        dark: '#1e3a8a',
        bg: '#f1f5f9',
        white: '#ffffff',
        text: '#0f172a',
        muted: '#64748b'
    };

    // --- STYLING TOKENS ---
    const stylesNew = {
        menuPaper: {
            width: 400,
            maxHeight: '92vh',
            backgroundColor: '#ffffff',
            borderRadius: '32px',
            boxShadow: '0 30px 60px -12px rgba(16, 49, 143, 0.2)',
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '0 0 20px 0',
        },
        toggleHeader: {
            py: 2,
            px: 2,
            borderBottom: `1px solid ${themeNew.border}`,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            bgcolor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 1300,
        },
        sectionLabel: {
            px: 2,
            pt: 2,
            pb: 1,
            fontSize: '0.65rem',
            fontWeight: 900,
            textTransform: 'uppercase',
            letterSpacing: '0.12em',
            color: '#94a3b8',
        },
        iconCircle: (color, isMobile) => ({
            width: isMobile ? '48px' : '44px',
            height: isMobile ? '48px' : '44px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: `${color}15`,
            color: color,
            fontSize: isMobile ? '1.5rem' : '1.4rem',
            mb: 1,
        }),
        logoutBtn: {
            width: '100%',
            py: 1.2,
            borderRadius: '10px',
            fontWeight: 700,
            textTransform: 'none',
            fontSize: '0.85rem',
            color: '#ef4444',
            border: '1px solid #fee2e2',
            bgcolor: '#fef2f2',
            '&:hover': {
                bgcolor: '#fee2e2',
                borderColor: '#ef4444'
            }
        },
        authAction: {
            flex: 1,
            py: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            borderRadius: '10px',
            transition: 'all 0.2s ease',
            '&:hover': {
                bgcolor: 'rgba(37, 99, 235, 0.04)',
                '& .auth-text': {
                    color: themeNew.primary,
                }
            }
        },
        authText: {
            fontSize: '0.8rem',
            fontWeight: 600,
            color: themeNew.muted,
            transition: 'color 0.2s ease',
        },
        // CONTAINER THAT STRETCHES FULL WIDTH
        fullWidthContainer: {
            width: '100%',
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        // FLEX GRID SYSTEM: FORCES 3 PER ROW & FULL WIDTH
        flexGrid: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
        },
        flexItem: {
            // This math forces exactly 3 items per row at all times
            flex: '0 0 33.333333%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box',
        },
        featureTile: (color) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: '5px',
            borderRadius: '16px',
            backgroundColor: '#fff',
            border: `1px solid ${themeNew.border}`,
            transition: 'all 0.2s ease',
            cursor: 'pointer',
            '&:hover': {
                borderColor: color,
                transform: 'translateY(-2px)',
                boxShadow: `0 4px 12px ${color}15`
            }
        }),
    };


    const plannerFeatures = [
        { label: 'Concierge', icon: 'icon-magic-wand', color: '#027faf' },
        { label: 'Map', icon: 'icon-map', color: '#027faf' },
        { label: 'Details', icon: 'icon-settings-icons', color: '#027faf' },
        { label: 'Dates', icon: 'icon-calendar3', color: '#027faf' },
        { label: 'Attendees', icon: 'icon-group', color: '#027faf' },
        { label: 'Flights', icon: 'icon-airplane', color: '#027faf' },
        { label: 'Documents', icon: 'icon-file-lock', color: '#027faf' },
        { label: 'Notes', icon: 'icon-notebook', color: '#027faf' },
        { label: 'Ideas', icon: 'icon-lamp-bright', color: '#027faf' },
        { label: 'Budget', icon: 'icon-wallet', color: '#027faf' },
        { label: 'To-Do', icon: 'icon-checklist-time', color: '#027faf' },
        { label: 'Supplies', icon: 'icon-checklist2', color: '#027faf' },
        { label: 'Lodging', icon: 'icon-bed', color: '#027faf' },
        { label: 'Itinerary', icon: 'icon-calendar', color: '#027faf' },
        { label: 'Activities', icon: 'icon-list-heart', color: '#027faf' },
        { label: 'Meals', icon: 'icon-fork-knife2', color: '#027faf' },
        { label: 'Photos', icon: 'icon-picture2', color: '#027faf' },
        { label: 'Receipts', icon: 'icon-receipt', color: '#027faf' },
        { label: 'Messages', icon: 'icon-smartphone-text', color: '#027faf' },
        { label: 'Weather', icon: 'icon-sun-wind', color: '#027faf' },
        { label: 'Save', icon: 'icon-floppy-disk', color: '#027faf' },
        { label: 'Clear', icon: 'icon-trash', color: '#027faf' },
    ];


    const AuthHeader = () => (
        <Box sx={{ display: 'flex', gap: 0, mb: 3, bgcolor: 'rgba(255,255,255,0.5)', borderRadius: '12px', p: 0.5, border: '1px solid #e2e8f0' }}>
            <Box
                sx={stylesNew.authAction}
                onClick={() => handleEventFeaturesMenuClick('Login')}
            >
                <Typography className="auth-text" sx={stylesNew.authText}>Log In</Typography>
            </Box>
            <Divider orientation="vertical" flexItem sx={{ my: 1, borderColor: '#e2e8f0' }} />
            <Box sx={stylesNew.authAction}>
                <Typography className="auth-text" sx={stylesNew.authText}>Create Account</Typography>
            </Box>
        </Box>
    );

    const LoggedInHeader = () => {
        // FIXED: Destructuring included internally to guarantee local variable definition scope safety
        const {
            totalAccountPoints,
            yearlyPoints,
            loadingEvents,
            getCurrentTier,
            getNextTier
        } = usePoints();

        const currentPoints = yearlyPoints + totalAccountPoints;
        const runningScoreTotal = currentPoints;
        const currentTierObj = getCurrentTier(currentPoints);

        const { progress, ptsToNextMilestone, isMaxTier } = useMemo(() => {
            const nextTierObj = getNextTier(currentPoints);

            if (!nextTierObj) {
                return {
                    progress: 100,
                    ptsToNextMilestone: 0,
                    isMaxTier: true
                };
            }

            const targetPoints = nextTierObj.min;
            const computedProgress = Math.min((currentPoints / targetPoints) * 100, 100);
            const distanceLeft = Math.max(0, targetPoints - currentPoints);

            return {
                progress: computedProgress,
                ptsToNextMilestone: distanceLeft,
                isMaxTier: false
            };
        }, [currentPoints, getNextTier]);

        return (
            <Box
                sx={{
                    maxWidth: '280px',
                    display: 'flex',
                    flexDirection: 'column', // Changed to column to save critical horizontal spacing
                    justifyContent: 'center',
                    overflow: 'hidden',
                    p: '12px 14px',
                    borderRadius: '16px',
                    backgroundColor: '#ffffff',
                    border: '1px solid rgba(0, 0, 0, 0.06)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.02)',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 6px 16px rgba(16, 49, 143, 0.08)',
                        borderColor: 'rgba(16, 49, 143, 0.2)',
                        '& .widget-mini-trophy': {
                            transform: 'scale(1.15) rotate(6deg)',
                        }
                    },
                }}
                onClick={() => {
                    if (typeof setAccountPointsDialogOpen === 'function') setAccountPointsDialogOpen(true);
                    if (typeof setAnchorAccountMenu === 'function') setAnchorAccountMenu(false);
                    if (typeof setAnchorAccountMenuMobile === 'function') setAnchorAccountMenuMobile(false);
                }}
            >
                {/* Top Row: Meta Heading Title + Tier Label Pill */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, width: '100%' }}>
                    <Typography
                        sx={{
                            fontWeight: 800,
                            color: '#94a3b8',
                            letterSpacing: '0.06em',
                            textTransform: 'uppercase',
                            fontSize: '0.62rem'
                        }}
                    >
                        Adventure
                    </Typography>

                    {/* Embedded Trophy Tier Badge */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            color: '#10318f',
                            backgroundColor: 'rgba(16, 49, 143, 0.06)',
                            padding: '3px 8px',
                            borderRadius: '20px',
                        }}
                    >
                        <i
                            className="icon-trophy widget-mini-trophy"
                            style={{
                                fontSize: '0.85rem',
                                color: '#f5b042',
                                transition: 'transform 0.2s ease-in-out'
                            }}
                        />
                        <Typography variant="caption" sx={{ fontWeight: 800, fontSize: '0.68rem', lineHeight: 1 }}>
                            {loadingEvents ? '...' : currentTierObj?.label || 'Explorer'}
                        </Typography>
                    </Box>
                </Box>

                {/* Middle Row: Grand Points Focus Header */}
                <Box sx={{ display: 'flex', alignItems: 'baseline', mb: 1 }}>
                    <Typography variant="h5" sx={{ fontWeight: 900, color: '#1e293b', lineHeight: 1, tracking: '-0.02em' }}>
                        {loadingEvents ? '...' : runningScoreTotal.toLocaleString()}
                    </Typography>
                    <Typography variant="caption" sx={{ ml: 0.5, fontWeight: 600, color: '#64748b', fontSize: '0.75rem' }}>
                        total pts
                    </Typography>
                </Box>

                {/* Bottom Row: Linear Progress Bar & Milestone Footnote */}
                <Box sx={{ width: '100%' }}>
                    <Box
                        sx={{
                            height: '5px',
                            width: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.05)',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            mb: '5px'
                        }}
                    >
                        <Box
                            sx={{
                                height: '100%',
                                width: `${progress}%`,
                                backgroundColor: '#10318f',
                                borderRadius: '10px',
                                background: 'linear-gradient(90deg, #10318f 0%, #1e40af 100%)',
                                transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
                            }}
                        />
                    </Box>

                    <Typography
                        sx={{
                            fontSize: '0.62rem',
                            color: '#64748b',
                            fontWeight: 600,
                            textAlign: 'left', // Flipped to left for cleaner trailing alignment with point values
                            display: 'block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {isMaxTier ? (
                            <span style={{ color: '#16a34a', fontWeight: 700 }}>★ Max Tier Reached!</span>
                        ) : (
                            `${ptsToNextMilestone.toLocaleString()} pts to next milestone`
                        )}
                    </Typography>
                </Box>
            </Box>
        );
    };

    const ToolkitGrid = () => {
        // 1. Fetch the current planning status from your global store
        const currentStatus = usePA_GlobalStore(state => state.PA_GlobalObject?.Planning?.status);

        // 2. Filter the array on the fly before rendering
        const visibleFeatures = plannerFeatures.filter(feature => {
            if (feature.label === 'Save') {
                return currentStatus === 10;
            }
            return true; // Keep all other features
        });

        return (
            <Box
                sx={{
                    maxHeight: '350px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    pr: 0.5,
                    '&::-webkit-scrollbar': { width: '4px' },
                    '&::-webkit-scrollbar-thumb': { bgcolor: '#cbd5e1', borderRadius: '4px' }
                }}
            >
                <Box sx={stylesNew.flexGrid}>
                    {/* 3. Map over your filtered visibleFeatures array instead */}
                    {visibleFeatures.map((f, i) => (
                        <Box key={i} sx={stylesNew.flexItem}>
                            <Box
                                sx={stylesNew.featureTile(f.color)}
                                onClick={() => handleEventFeaturesMenuClick(f.label)}
                            >
                                <Box sx={stylesNew.iconCircle(f.color)}>
                                    <i className={f.icon} />
                                </Box>
                                <Typography sx={{ fontSize: '0.65rem', fontWeight: 800, color: '#1e293b' }}>
                                    {f.label}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    };

    const EventList = () => (
        <Accordion
            expanded={expandedAccordions.includes('eventList')}
            onChange={handleAccordionChange('eventList')}
            sx={accordionSummarySx}
        >
            <AccordionSummary
                expandIcon={<i className='icon-chevron-down' />}
                aria-controls="event-list-content"
                id="event-list-header"
            >
                <ListItemIcon sx={listItemTopLevelIconSx}><i className="icon-calendar"/></ListItemIcon>
                <Typography sx={listItemTopLevelTextSx}>Events</Typography>
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsSx}>
                <List disablePadding dense>
                    {/* put the option here for creating a new Event */}
                    <ListItem
                        disablePadding
                        sx={{
                            borderRadius: '5px',
                            mb: 1,
                            mt: 1,
                            background: 'linear-gradient(135deg, #e0f7fa, #f1f8e9)',
                            boxShadow: '0 3px 10px rgba(0,0,0,0.06)',
                            transition: 'all 0.25s ease',
                            '&:hover': {
                                boxShadow: '0 6px 14px rgba(0,0,0,0.12)',
                                transform: 'translateY(-2px)',
                                cursor: 'pointer',
                            }
                        }}
                    >
                        <ListItemButton onClick={handleCreateNewEventClick}>
                            <ListItemIcon sx={{ minWidth: 48 }}>
                                <Box
                                    sx={{
                                        backgroundColor: '#4caf50',
                                        color: '#fff',
                                        borderRadius: '10px',
                                        width: 36,
                                        height: 36,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '18px',
                                        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
                                    }}
                                >
                                    📆
                                </Box>
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#2e7d32' }}>
                                        Create New Event
                                    </Typography>
                                }
                                secondary={
                                    <Typography variant="caption" color="textSecondary">
                                        Plan something exciting — your way!
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>

                    {/* now list all of the Users Events */}
                    {
                        sortedEvents.length > 0 ? (
                            <List disablePadding dense>
                                {sortedEvents.map((_event) => {
                                    // 1. Check if this specific list item is the one being edited
                                    const isActive = PA_GlobalObject?.Planning?.id === _event.id;

                                    // 2. Use the live Planning object if it matches, otherwise use the list version
                                    const eventData = isActive ? PA_GlobalObject.Planning : _event;

                                    return (
                                        <EventCard
                                            key={_event.id}
                                            event={eventData} // This ensures the new coverImage shows up here too!
                                            accountId={Account.id}
                                            onClick={handleEventMenuClick}
                                        />
                                    );
                                })}
                            </List>
                        ) : (
                            <ListItem>
                                <ListItemText primary={<Typography sx={listItemTextSx}>No events found.</Typography>} />
                            </ListItem>
                        )
                    }
                </List>
            </AccordionDetails>
        </Accordion>
    );

    const AccountSection = () => (
        <Box sx={{ mt: 4, width: '100%', px: 2 }}>
            <Typography sx={{ fontSize: '0.65rem', fontWeight: 900, color: '#94a3b8', textTransform: 'uppercase', mb: 2 }}>
                Account
            </Typography>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <ListItemButton sx={{ borderRadius: '12px', bgcolor: '#fff', border: '1px solid #f1f5f9' }}>
                        <ListItemIcon sx={{ minWidth: 32, color: '#10318f' }}><i className="icon-calendar3" /></ListItemIcon>
                        <ListItemText primary="Calendar" primaryTypographyProps={{ fontSize: '0.75rem', fontWeight: 600 }} />
                    </ListItemButton>
                    <ListItemButton sx={{ borderRadius: '12px', bgcolor: '#fff', border: '1px solid #f1f5f9' }}>
                        <ListItemIcon sx={{ minWidth: 32, color: '#10318f' }}><i className="icon-checklist-time" /></ListItemIcon>
                        <ListItemText primary="To Do" primaryTypographyProps={{ fontSize: '0.75rem', fontWeight: 600 }} />
                    </ListItemButton>
                    <ListItemButton sx={{ borderRadius: '12px', bgcolor: '#fff', border: '1px solid #f1f5f9' }}>
                        <ListItemIcon sx={{ minWidth: 32, color: '#10318f' }}><i className="icon-calendar" /></ListItemIcon>
                        <ListItemText primary="Settings" primaryTypographyProps={{ fontSize: '0.75rem', fontWeight: 600 }} />
                    </ListItemButton>
                </Grid>
            </Grid>
        </Box>
    );

    const resources = [
        { label: 'Browse Templates', icon: 'icon-files2' },
        { label: 'View Pricing', icon: 'icon-wallet' },
        { label: 'Community Guide', icon: 'icon-group' },
        { label: 'Contact Support', icon: 'icon-envelope' },
    ];

    const ResourceSection = () => (
        <Box sx={{ mt: 4, width: '100%', px: 2 }}>
            <Typography sx={{ fontSize: '0.65rem', fontWeight: 900, color: '#94a3b8', textTransform: 'uppercase', mb: 2 }}>
                Resources & Support
            </Typography>
            <Grid container spacing={1}>
                {resources.map((r) => (
                    <Grid item xs={6} key={r.label}>
                        <ListItemButton sx={{ borderRadius: '12px', bgcolor: '#fff', border: '1px solid #f1f5f9' }}>
                            <ListItemIcon sx={{ minWidth: 32, color: '#10318f' }}><i className={r.icon} /></ListItemIcon>
                            <ListItemText primary={r.label} primaryTypographyProps={{ fontSize: '0.75rem', fontWeight: 600 }} />
                        </ListItemButton>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );

    const LoggedInFooter = () => (
        <Box sx={{ width: '100%', px: 1, mb: 3 }}>
            <Button sx={styles.logoutBtn} onClick={() => console.log('Logging out...')}>
                Logout
            </Button>
        </Box>
    );

    // --- MOBILE VIEW ---
    const MobileViewNew = (
        <div>
            {/* the top line for both authenticated and not authenticated */}
            {authenticated ? <LoggedInHeader /> : <AuthHeader />}

            {/* the list of all event features */}
            <Box sx={{ textAlign: 'center'}}>
                <Typography variant="h5" sx={{ fontWeight: 900, color: '#0f172a' }}>Adventure Planner</Typography>
                <Typography variant="body2" color="text.secondary">Professional Grade Travel Tools</Typography>
            </Box>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                <Fade in>
                    <Box sx={stylesNew.fullWidthContainer}>
                        <ToolkitGrid />
                    </Box>
                </Fade>
            </Box>

            {/* the list of all events */}
            {authenticated && (
                <EventList />
            )}

            {/* the list of Account items */}
            <AccountSection />

            {/* the list of all public pages */}
            <ResourceSection />

            {/* the logout button if they are logged in */}
            {authenticated ? <LoggedInFooter /> : <></>}
        </div>
    );




    const handleFeatureClick = (id) => console.log("Launching:", id);

    {/* Tooltip Content Component */}
    const tooltipUsersContent = (
        <Box sx={{ p: 0.5, maxWidth: 320 }}>
            <Typography
                variant="caption"
                fontWeight="bold"
                sx={{ borderBottom: '1px solid rgba(255,255,255,0.2)', display: 'block', pb: 0.5, mb: 0.5 }}
            >
                {ws_connected ? `Connected Sessions (${activeConnectedUsers?.length || activeConnectionCount})` : "Disconnected"}
            </Typography>
            {ws_connected && activeConnectedUsers && activeConnectedUsers.length > 0 ? (
                <List dense disablePadding>
                    {activeConnectedUsers.map((u, idx) => {
                        // Truncate long session IDs for display (e.g. "a1b2c3d4...")
                        const shortSessionId = u.session_id
                            ? (u.session_id.length > 10 ? `${u.session_id.substring(0, 8)}...` : u.session_id)
                            : null;

                        return (
                            <ListItem
                                key={u.session_id || u.id || idx}
                                disableGutters
                                sx={{
                                    py: 0.5,
                                    borderBottom: idx < activeConnectedUsers.length - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none'
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                            <Typography variant="caption" fontWeight={600} color="#fff">
                                                {u.name || 'Anonymous User'}
                                            </Typography>
                                            {u.ip_address && (
                                                <Chip
                                                    label={u.ip_address}
                                                    size="small"
                                                    sx={{
                                                        height: 16,
                                                        fontSize: '0.625rem',
                                                        color: 'rgba(255,255,255,0.9)',
                                                        bgcolor: 'rgba(255,255,255,0.15)',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    }
                                    secondary={
                                        <Box component="span" sx={{ display: 'block', mt: 0.25 }}>
                                            {u.email && (
                                                <Typography component="span" display="block" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.68rem' }}>
                                                    {u.email}
                                                </Typography>
                                            )}
                                            {shortSessionId && (
                                                <Typography component="span" display="block" sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.62rem', fontFamily: 'monospace' }}>
                                                    ID: {shortSessionId}
                                                </Typography>
                                            )}
                                        </Box>
                                    }
                                />
                            </ListItem>
                        );
                    })}
                </List>
            ) : (
                <Typography variant="caption" color="inherit">
                    {ws_connected ? "No user details available" : "Reconnecting to server..."}
                </Typography>
            )}
        </Box>
    );



    return (

        <Container
            sx={{
                position: 'sticky',
                top : 0,
                maxWidth: '100% !important',
                padding: '0 !important',
                zIndex: 1,
                overflow: 'auto'
            }}>

            <LinearProgress variant="determinate" value={progressBarIndicator} />

            {
                showHeader && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingLeft: (authenticated ? (dataArray.sideMenuWidth === 0 ? 0 : dataArray.sideMenuWidth + "px") : 0),
                        position: 'relative',
                        top: 0,
                        left: 0,
                        backdropFilter: 'blur(6px)',
                        backgroundColor: 'rgba(249, 250, 251, 0.8)',
                        zIndex: 1
                    }}>
                        <div
                            className="logo-holder"
                            style={{
                                position: 'relative',
                                display: 'inline-flex',
                                alignItems: 'center'
                            }}
                        >
                            {/* Top-Left Badge Overlay */}
                            <Tooltip title={tooltipUsersContent} arrow placement="bottom-start" enterDelay={100}>
                                <div
                                    id="ws_connection"
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        left: '0',
                                        zIndex: 2,
                                        backgroundColor: ws_connected ? "#10b981" : "#ef4444",
                                        color: "#ffffff",
                                        minWidth: "16px",
                                        height: "16px",
                                        padding: "0 4px",
                                        borderRadius: "10px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "9px",
                                        fontWeight: 800,
                                        lineHeight: 1,
                                        userSelect: "none",
                                        boxShadow: ws_connected
                                            ? "0 0 6px rgba(16, 185, 129, 0.6)"
                                            : "0 0 6px rgba(239, 68, 68, 0.6)",
                                        transition: "all 0.3s ease",
                                        pointerEvents: "auto", // Updated from 'none' to allow hover events
                                        cursor: "pointer"
                                    }}
                                >
                                    {ws_connected ? activeConnectionCount : ""}
                                </div>
                            </Tooltip>

                            {/* Desktop Logo */}
                            <Box sx={{display: {md: 'block', xs: 'none'}}}>
                                <img
                                    className="logo-large"
                                    src={large_logo}
                                    onClick={onLogoClick}
                                    alt=""
                                    style={{display: 'block'}}
                                />
                            </Box>

                            {/* Mobile Logo */}
                            <Box sx={{display: {md: 'none', xs: 'block'}}}>
                                <img
                                    className="logo"
                                    src={small_logo}
                                    onClick={onLogoClick}
                                    alt=""
                                    style={{display: 'block'}}
                                />
                            </Box>
                        </div>

                        {/* Desktop links */}
                        <Box sx={{display: {md: 'block', xs: 'none'}}}>
                            <div style={{justifyContent: 'flex-end'}}>
                                <List style={{display: 'flex', alignItems: 'center', padding: '0'}}>

                                    {
                                        authenticated ? (
                                            <>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'templates' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Templates"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'events' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Events"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'contacts' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Contacts"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className="underline"
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Lists"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'planner' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Planner"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'flightplanner' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="FlightPlanner"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                {
                                                    Account.role === "master_admin" ? (
                                                        <ListItemButton
                                                            className={selectedMenuItem === 'nano' ? 'show-underline' : 'underline'}
                                                            onClick={onButtonClick}
                                                        >
                                                            <ListItemText
                                                                primary="Nano"
                                                                primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                            />
                                                        </ListItemButton>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                {
                                                    Account.role === "master_admin" ? (
                                                        <ListItemButton
                                                            className={selectedMenuItem === 'admins' ? 'show-underline' : 'underline'}
                                                            onClick={onButtonClick}
                                                        >
                                                            <ListItemText
                                                                primary="Admins"
                                                                primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                            />
                                                        </ListItemButton>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <ListItemButton
                                                    onClick={() => setGettingStartedDialogOpen(!isGettingStartedDialogOpen)}
                                                >
                                                    <i className="icon-question-circle"
                                                       style={{fontSize: '20px', padding: '5px'}}/>
                                                </ListItemButton>
                                                <Box
                                                    onClick={handleAccountMenuOpenMenu}
                                                    sx={{
                                                        width: 60,
                                                        height: 60,
                                                        borderRadius: '50%',
                                                        backdropFilter: 'blur(10px)',
                                                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                                        boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                                        }
                                                    }}
                                                >
                                                    {!Account.avatar?.preview ? (
                                                        <Avatar
                                                            {...stringAvatar(`${formatName(Account.fname)}, ${formatName(Account.lname)}`)}
                                                            sx={{
                                                                width: 50,
                                                                height: 50,
                                                                fontSize: '16px',
                                                                backgroundColor: '#fff',
                                                                color: '#000',
                                                                border: `1px solid ${stringToColor(`${formatName(Account.fname)}, ${formatName(Account.lname)}`)}`,
                                                            }}
                                                        />
                                                    ) : (
                                                        <Avatar
                                                            src={Account.avatar.preview}
                                                            sx={{
                                                                width: 50,
                                                                height: 50,
                                                                border: `1px solid ${stringToColor(`${formatName(Account.fname)}, ${formatName(Account.lname)}`)}`,
                                                            }}
                                                        />
                                                    )}
                                                </Box>

                                                <Menu
                                                    anchorEl={anchorAccountMenu}
                                                    open={Boolean(anchorAccountMenu)}
                                                    onClose={handleAccountMenuClose}
                                                    PaperProps={{
                                                        sx: {
                                                            width: 280,
                                                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                                            backdropFilter: 'blur(15px)',
                                                            borderRadius: '12px',
                                                            boxShadow: '0 8px 32px rgba(31, 38, 135, 0.37)',
                                                            padding: 1,
                                                            mt: 1.5,
                                                        },
                                                    }}

                                                    transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                                                >
                                                    {
                                                        authenticatedDesktopNavItems
                                                    }
                                                </Menu>
                                            </>
                                        ) : (
                                            <>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'features' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Features"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'pricing' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Pricing"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'contact' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Contact Us"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'templates' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Templates"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'planner' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Planner"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'login' ? 'show-underlined' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Login"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                                <ListItemButton
                                                    className={selectedMenuItem === 'signup' ? 'show-underline' : 'underline'}
                                                    onClick={onButtonClick}
                                                >
                                                    <ListItemText
                                                        primary="Sign Up"
                                                        primaryTypographyProps={{style: {fontSize: '14px'}}}
                                                    />
                                                </ListItemButton>
                                            </>
                                        )
                                    }

                                </List>
                            </div>
                        </Box>

                        {/* Event title for mobile */}
                        <Box sx={{display: {md: 'none', xs: 'block'}}}>
                            {eventTitle}
                        </Box>

                        {isMobileView && (
                            <>
                                {isSyncing && (
                                    <div className="sync-dots" title="Saving changes...">
                                        <div className="sync-dot"></div>
                                        <div className="sync-dot"></div>
                                        <div className="sync-dot"></div>
                                    </div>
                                )}

                                {/* State 2: Success! */}
                                {showCloudSuccess && (
                                    <div className="cloud-save-indicator" style={{animation: 'fadeIn 0.3s'}}>
                                        <i
                                            className="icon-cloud-check"
                                            style={{
                                                fontSize: '25px',
                                                color: '#4caf50',
                                                marginRight: '20px'
                                            }}
                                        />
                                    </div>
                                )}
                            </>
                        )}

                        {/* icon for mobile */}
                        <Box sx={{display: {md: 'none', xs: 'block'}}}>
                            <Box
                                onClick={handleAccountMenuMobileOpenMenu}
                                sx={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: '50%',
                                    backdropFilter: 'blur(10px)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                    }
                                }}
                            >
                                {
                                    !authenticated ? (
                                        <i className="icon-menu2"></i>
                                    ) : !Account.avatar?.preview ? (
                                        <Avatar
                                            {...stringAvatar(`${formatName(Account.fname)}, ${formatName(Account.lname)}`)}
                                            sx={{
                                                width: 50,
                                                height: 50,
                                                fontSize: '16px',
                                                backgroundColor: '#fff',
                                                color: '#000',
                                                border: `1px solid ${stringToColor(`${formatName(Account.fname)}, ${formatName(Account.lname)}`)}`,
                                            }}
                                        />
                                    ) : (
                                        <Avatar
                                            src={Account.avatar.preview}
                                            sx={{
                                                width: 50,
                                                height: 50,
                                                border: `1px solid ${stringToColor(`${formatName(Account.fname)}, ${formatName(Account.lname)}`)}`,
                                            }}
                                        />
                                    )
                                }
                            </Box>
                            <Menu
                                anchorEl={anchorAccountMenuMobile}
                                open={Boolean(anchorAccountMenuMobile)}
                                onClose={handleAccountMenuMobileClose}
                                PaperProps={{
                                    sx: {
                                        width: 280,
                                        backgroundColor: '#fff',
                                        borderRadius: '12px',
                                        boxShadow: '0 8px 32px rgba(31, 38, 135, 0.37)',
                                        padding: 0,
                                    },
                                }}

                                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                            >

                                {/* show the menu items */}
                                {
                                    MobileViewNew
                                }
                            </Menu>

                        </Box>
                    </div>
                )
            }


            <Dialog
                sx={{'& .MuiDialog-paper': {maxHeight: 435}}}
                open={isModalOpen}
            >
                <DialogTitle>Please Login</DialogTitle>

                <DialogContent>

                    <GoogleLogin
                        shape="pill"
                        onSuccess={credentialResponse => {
                            console.log(credentialResponse.credential);

                            setLoginFailed(false);

                            //send this to the server for processing
                            const _sendString = {};
                            _sendString.action = "E_processUserLoginUsingGoogleJWT";
                            _sendString.jwt = credentialResponse;

                            sendSocketMessage(_sendString);

                        }}
                        onError={() => {
                            console.log('Login Failed');
                        }}
                    />

                    <div style={{marginTop: '20px', marginBottom: '20px'}}>
                        <Divider>
                            <Chip label="OR"/>
                        </Divider>
                    </div>

                    <FormControl sx={{m: 1, width: '25ch'}} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-username">Username</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-username"
                            variant="outlined"
                            type="text"
                            label="Username"
                            onChange={handleUsernameInputChange}
                            value={username}
                            error={usernameErrorStatus}
                        />
                        {usernameErrorStatus && (
                            <FormHelperText sx={{color:"red"}}>* required</FormHelperText>
                        )}
                    </FormControl>
                    <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            variant="outlined"
                            type={showPassword ? 'text' : 'password'}
                            label="Password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            onChange={handlePasswordInputChange}
                            value={password}
                            error={passwordErrorStatus}
                        />
                        {passwordErrorStatus && (
                            <FormHelperText sx={{color:"red"}}>* required</FormHelperText>
                        )}
                    </FormControl>

                </DialogContent>


                {dataArray.loginFailed && (
                    <Alert severity="error">Incorrect username or password</Alert>
                )}


                <DialogActions>
                    <Button autoFocus onClick={handleCancel}>Cancel</Button>
                    <Button onClick={handleOk}>Ok</Button>
                </DialogActions>
            </Dialog>

            {accountPointsDialogOpen && (
                <UnifiedPoints
                    isOpen={accountPointsDialogOpen}
                    onClose={() => setAccountPointsDialogOpen(false)}
                />
            )}

            {eventPointsDialogOpen && (
                <UnifiedPoints
                    isOpen={eventPointsDialogOpen}
                    onClose={() => setEventPointsDialogOpen(false)}
                />
            )}

            {/* Account Dialog */}
            {showAccountDialog && (
                <AccountDialog
                    isOpen={showAccountDialog}
                    onClose={() => setShowAccountDialog(false)}
                />
            )}


            {/* Templates Dialog */}
            <MasterTemplates
                dialogRefTemplates={dialogRefTemplates}
                isTemplatesDialogOpen={isTemplatesDialogOpen}
                closeTemplatesDialog={closeTemplatesDialog}
                handleTemplateMenuClick={handleTemplateMenuClick}
            />

            {/* Event Dialog */}
            {isEventDialogOpen && (
                <Dialog
                    ref={dialogRefEvent}
                    open={isEventDialogOpen}
                    onClose={closeEventDialog}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>{sortedEvents.length} Event{sortedEvents.length===1?'':'s'}</DialogTitle>
                    <Tooltip title="Sort">
                        <IconButton
                            aria-label="Sort"
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 250,
                                top: 8,
                                color: theme.palette.grey[700],
                                cursor: 'pointer',
                                fontSize: '18px',
                            })}
                            onClick={handleSortToggle}
                        >
                            <i
                                className="icon-sort-time-desc"
                                style={{
                                    color: 'green',
                                    fontSize: '18px',
                                    padding: '10px',
                                    cursor: 'pointer'
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Filter">
                        <IconButton
                            aria-label="Filter"
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 200,
                                top: 8,
                                color: theme.palette.grey[700],
                                cursor: 'pointer',
                                fontSize: '18px',
                            })}
                            onClick={handleFilterMenuOpen}
                        >
                            <Badge
                                badgeContent={selectedLocations.length + selectedEventAttendees.length}  // Show number of selected categories
                                sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: 'white', // Customize the dot color here
                                        border: '1px solid', // Make it a circle
                                        width: '15px', // Adjust the dot size as needed
                                        height: '15px',
                                        color: 'green',
                                        fontWeight: '700',
                                        borderRadius: '35%', // Make it a circle
                                        top: '7px', // Adjust top and right values to move the dot
                                        right: '7px', // Adjust top and right values to move the dot
                                    },
                                }}
                                invisible={selectedLocations.length + selectedEventAttendees.length === 0} // Hide the badge if none are selected
                            >
                                <i
                                    className="icon-funnel"
                                    style={{
                                        color: 'green',
                                        fontSize: '18px',
                                        padding: '10px',
                                        cursor: 'pointer'
                                    }}
                                />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorElFilter}
                        open={Boolean(anchorElFilter)}
                        onClose={handleFilterMenuClose}

                    >
                        {/* Locations Section */}
                        <List
                            subheader={
                                <ListSubheader
                                    sx={{ bgcolor: 'rgba(198, 226, 255, 0.8)', color: '#343a40' }}
                                >
                                    Locations
                                </ListSubheader>
                            }
                            dense
                        >
                            {Object.keys(uniqueLocations)
                                .sort()
                                .map((state) => (
                                    <div key={state}>
                                        {/* Display the state as a header */}
                                        <MenuItem disabled>
                                            <ListSubheader
                                                sx={{ color: '#151269' }}
                                            >
                                                {state.toUpperCase()}
                                            </ListSubheader>
                                        </MenuItem>

                                        {/* Display cities for that state */}
                                        {uniqueLocations[state]
                                            .sort()
                                            .map((city) => {
                                                const location = `${city}, ${state}`;
                                                return (
                                                    <MenuItem
                                                        key={location}
                                                        onClick={() => handleLocationToggle(location)}
                                                        sx={{ display: 'flex', justifyContent: 'space-between' }}
                                                    >
                                                        <Typography>{city}</Typography>
                                                        <Checkbox
                                                            checked={selectedLocations.includes(location)}
                                                            edge="end"
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={() => handleLocationToggle(location)} // Toggle Location selection
                                                        />
                                                    </MenuItem>
                                                );
                                            })}
                                    </div>
                                ))}
                        </List>

                        {/* Attendees Section */}
                        <List
                            subheader={
                                <ListSubheader
                                    sx={{ bgcolor: 'rgba(198, 226, 255, 0.8)', color: '#151269' }} // Same light blue background and darker gray for attendees section title
                                >
                                    Attendees
                                </ListSubheader>
                            }
                            dense
                        >
                            {Attendees
                                .sort((a, b) => (a.fname || '').localeCompare(b.fname || ''))
                                .map((attendee) => (
                                    <MenuItem
                                        key={attendee.id}
                                        onClick={() => handleEventAttendeeToggle(attendee.id)}
                                        sx={{ display: 'flex', justifyContent: 'space-between' }} // Align label to the left and checkbox to the right
                                    >
                                        <Typography>{`${capitalizeFirstLetter(attendee.fname)} ${capitalizeFirstLetter(attendee.lname)}`}</Typography>
                                        <Checkbox
                                            checked={selectedEventAttendees.includes(attendee.id)}
                                            edge="end"
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={() => handleEventAttendeeToggle(attendee.id)} // Toggle Attendee selection
                                        />
                                    </MenuItem>
                                ))}
                        </List>
                    </Menu>

                    {
                        uniqueCategories.length > 0 && (
                            <>
                                <Tooltip title="Categories">
                                    <IconButton
                                        aria-label="Categories"
                                        sx={(theme) => ({
                                            position: 'absolute',
                                            right: 150,
                                            top: 8,
                                            color: theme.palette.grey[700],
                                            cursor: 'pointer',
                                            fontSize: '18px',
                                        })}
                                        onClick={handleCategoryMenuOpen} // Open the menu on click
                                    >
                                        <Badge
                                            badgeContent={selectedCategories.length}  // Show number of selected categories
                                            sx={{
                                                '& .MuiBadge-badge': {
                                                    backgroundColor: 'white', // Customize the dot color
                                                    border: '1px solid', // Border to make it stand out
                                                    width: '15px', // Adjust the dot size as needed
                                                    height: '15px',
                                                    color: 'green', // Badge text color
                                                    fontWeight: '700',
                                                    borderRadius: '50%', // Perfect circle
                                                    top: '7px', // Adjust top position of the badge
                                                    right: '7px', // Adjust right position of the badge
                                                },
                                            }}
                                            invisible={selectedCategories.length === 0} // Hide badge if none are selected
                                        >
                                            <i
                                                className="icon-folder-heart"
                                                style={{
                                                    color: 'green',
                                                    fontSize: '18px',
                                                    padding: '10px',
                                                    cursor: 'pointer',
                                                }}
                                            />
                                        </Badge>
                                    </IconButton>
                                </Tooltip>

                                {/* Category Menu */}
                                <Menu
                                    anchorEl={anchorElCategory}
                                    open={Boolean(anchorElCategory)}
                                    onClose={handleCategoryMenuClose}
                                >
                                    <List
                                        subheader={
                                            <ListSubheader
                                                sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold', color: '#888' }}
                                            >
                                                Categories
                                            </ListSubheader>
                                        }
                                        dense
                                    >
                                        {
                                            uniqueCategories
                                            .sort()
                                            .map((category) => (
                                                <MenuItem key={category} onClick={() => handleCategoryToggle(category)}>
                                                    <ListItemText primary={category} />
                                                    <Checkbox
                                                        edge="end"
                                                        checked={selectedCategories.includes(category)}
                                                        onClick={(e) => e.stopPropagation()} // Prevent parent click event
                                                        onChange={() => handleCategoryToggle(category)} // Toggle category selection
                                                    />
                                                </MenuItem>
                                            ))
                                        }
                                    </List>
                                </Menu>
                            </>
                        )
                    }

                    <Tooltip title="Search">
                        <IconButton
                            aria-label="Search"
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 100,
                                top: 8,
                                color: theme.palette.grey[700],
                                cursor: 'pointer',
                                fontSize: '18px',
                            })}
                        >
                            <i
                                className="icon-search"
                                style={{
                                    color: 'red',
                                    fontSize: '18px',
                                    padding: '10px',
                                    cursor: 'pointer'
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Reset">
                        <IconButton
                            aria-label="Reset"
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 50,
                                top: 8,
                                color: theme.palette.grey[700],
                                cursor: 'pointer',
                                fontSize: '18px',
                            })}
                            onClick={handleReset}
                        >
                            <i
                                className="icon-cw"
                                style={{
                                    color: 'green',
                                    fontSize: '18px',
                                    padding: '10px',
                                    cursor: 'pointer'
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Close">
                        <IconButton
                            aria-label="Close"
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 0,
                                top: 8,
                                color: theme.palette.grey[700],
                                cursor: 'pointer',
                                fontSize: '18px',
                            })}
                            onClick={closeEventDialog}
                        >
                            <i
                                className="icon-cross"
                                style={{
                                    color: 'green',
                                    fontSize: '18px',
                                    padding: '10px',
                                    cursor: 'pointer'
                                }}
                            />
                        </IconButton>
                    </Tooltip>

                    <DialogContent>
                        <Grid container spacing={2}>
                            {sortedEvents.map((event) => {
                                // 1. Check if this specific event is the one currently in the Planner/Details view
                                const isActiveEvent = PA_GlobalObject?.Planning?.id === event.id;

                                // 2. If it's active, use the live object. If not, use the version from the list.
                                const eventData = isActiveEvent ? PA_GlobalObject.Planning : event;

                                return (
                                    <Grid item key={event.id} sx={{ width: calculateCardWidth() }}>
                                        <EventCard
                                            event={eventData} // Passes the updated coverImage instantly
                                            accountId={Account.id}
                                            onClick={handleEventMenuClick}
                                            width={calculateCardWidth()}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </DialogContent>

                </Dialog>
            )}

            {/* Contacts Dialog */}
            {isAttendeesDialogOpen && (
                <MasterAttendees
                    dialogRefAttendees={dialogRefAttendees}
                    isAttendeesDialogOpen={isAttendeesDialogOpen}
                    closeAttendeesDialog={closeAttendeesDialog}
                    isEventDialogOpen={isEventDialogOpen}
                    isUploadModeOn={false}
                />
            )}

            {/* Unified Budget Dialog */}
            {isUnifiedBudgetDialogOpen && (
                <UnifiedBudget
                    isOpen={isUnifiedBudgetDialogOpen}
                    onClose={() => setIsUnifiedBudgetDialogOpen(false)}
                />
            )}

            {/* Master Calendar Dialog */}
            {masterCalendarDialogOpen && (
                <MasterCalendar
                    isOpen={masterCalendarDialogOpen}
                    onClose={handleMasterCalendarClose}
                    />
            )}

            {/* Master To-Do List Dialog */}
            {todoDialogOpen && (
                <ToDoMaster
                    isOpen={todoDialogOpen}
                    onClose={handleToDoClose}
                    toDoItems={toDoItems}/>
            )}


            {/* Render the Dialog only when active */}
            {showAnalyzer && (
                <Analyzer
                    Account={Account}
                    Events={dataArray.Events}
                    onClose={() => setShowAnalyzer(false)}
                />
            )}

            <MasterLists
                open={isMasterListsDialogOpen}
                onClose={() => setIsMasterListsDialogOpen(false)}
                allEvents={sortedEvents} // Passes sorted list extracted locally from IndexedDB
                PA_GlobalObject={PA_GlobalObject}
                set_PA_GlobalObject={set_PA_GlobalObject}
                Account={Account}
                sendSocketMessage={sendSocketMessage}
            />

            {isSavePlanningDialogOpen && (
                <SavePlanning
                    isOpen={isSavePlanningDialogOpen}
                    onClose={() => setIsSavePlanningDialogOpen(false)}
                />
            )}

            <GettingStarted
                isOpen={isGettingStartedDialogOpen}
                onClose={() => setGettingStartedDialogOpen(false)}
            />

            <Dialog
                open={openDialogDelete}
                onClose={handleDialogDeleteClose}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete {attendeeToDeleteName}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogDeleteClose}>Cancel</Button>
                    <Button onClick={handleDialogDeleteOK} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>


        </Container>
    );
};

export default Header;
